/* MV Sortiment assets/mv-sortiment.businessplan.js · Agent D-B · 2026-10-08 */
/*
  Modul "businessplan" (Waechter window.__mvSortiment.businessplan; Listener nur auf window). Paket D-B, Inhaber
  08.10.2026 zu /pages/businessplan: "Kannst du das noch ein bisschen grafisch und inhaltsmaessig ueberarbeiten? Also
  den Business Plan der da erstellt wird." Erzeugt den Businessplan v2, ein bankfaehiges, druckfertiges Dokument
  (A4, Deckblatt, Zusammenfassung mit sechs Kennzahlen, Geschaeftsmodell, Angebot, Markt, Investitions-,
  Finanzierungs- und Abschreibungsplan, Umsatz- und Kostenplanung ueber 36 Monate, Rentabilitaet, Liquiditaet,
  Risiken, Anhang) aus denselben Eingaben wie bisher.

  Rechenkern bleibt rechnePlan() aus assets/mv-sortiment.vorlagen.js (dahinter rechne() aus
  assets/mv-sortiment.rechner.js mit den Annahmen des Rechenbeispiels D5). plan() hebt nur Leasingraten unter der
  Mindestrate der Partnerbank auf 100 EUR an (wie LEASING_MINDESTRATE im Finanzierungsvergleich); auswertung()
  rechnet aus dem fertigen Plan ab: Quartale, Deckungsbeitrag, Kostenstruktur, Kapitaldienst, Abschreibung je
  Anlagegut. Zahlen in festen Texten nur aus dem Katalog (addons.ts, Sortimentsmatrix), den D5-Annahmen, dem
  globalen Block der Zahlen-Whitelist und Normzitaten; alles andere kommt aus den Eingaben.

  Das Dokument hat die Struktur von vorlagen.js ({ werkzeug, version: 2, titel, untertitel, kopf, abschnitte,
  anlagen, unterschriften, rechtshinweis, stand }) mit den bisherigen Bausteinen absatz, liste und hinweis und
  eigenen Bausteinen: bp-deckblatt, bp-angaben, bp-kpis, bp-tabelle (Zeilenarten summe und zwischen, Rohwerte),
  bp-diagramm (balken-jahre, balken-monate, linie, ring; SVG ohne Bibliothek) und bp-verweis. vorlagen.js reicht
  Bausteine fremder Art an blockText, blockMarkdown, blockHtml und blockDom dieses Moduls weiter (unter Node nach
  erweitere(), im Browser ueber den Waechter) und haengt druckCss() an die HTML-Datei. Gestaltung:
  assets/mv-sortiment.bp.css (Klassen mv-bp-*); Icons der Kennzahlen als Vorlagen aus
  snippets/mv-businessplan-dokument.liquid. Sichtbare Texte mit Umlauten als Unicode-Escapes (Datei bleibt ASCII).
  Doku _docs/db-businessplan.md.

  Nachtrag K-A (08.10.2026, _docs/ka-kosmetik.md; Befunde der Screenshot-Runde r18b): (1) Platzhalter in einer Form
  ohne Punkt (OFFEN), beim Betreiber ohne Namen mit Mittelpunkt vor der Rechtsform statt "ausgefuellt., ...";
  (2) Vorschau im Blatt: das Modul misst nach jedem Zeichnen und bei jeder Breitenaenderung (ResizeObserver), wie
  breit das Dokument sein muss, damit keine Tabelle und kein Diagramm ueberlaeuft, und setzt es so breit (mindestens
  die Seitenbreite 45rem); passt das mit einem Faktor von mindestens 0,8 auf das Blatt, verkleinert zoom das ganze
  Dokument (Seitenansicht: data-mv-bp-vorschau="seite", Faktor als --mvs-bp-skala am Dokumentbereich), sonst fliesst
  es wie bisher. Ueber jeder Tabelle und jedem breiten Diagramm steht im Blatt ein Hinweis "wischen" (aria-hidden),
  sichtbar nur, wenn der Bereich wirklich ueberlaeuft. Datei, Text, Markdown und Druck bleiben unveraendert.

  Nachtrag A-2a (10.10.2026, _docs/a2a-konto-speicherschicht.md): Bruecke zum Kundenkonto. Das Formular gehoert
  weiter assets/mv-sortiment.vorlagen.js (Paket A-2b), das die Eingaben wie bisher im Browser-Speicher unter
  SPEICHER.businessplan haelt; dieses Modul bringt denselben Stand ueber MVKonto (assets/mv-sortiment.konto.js) unter
  dem Werkzeug-Schluessel "businessplan" in den Spiegel und mit Login ins Konto: { v: 1, werte (Felder wie
  vorlagen.js sie liest), schritt, titel = Name des Vorhabens }. Der Altschluessel ist mit MVKonto geteilt (Adapter
  ueber MVKonto.migration mit leseZustand/zustandText aus vorlagen.js): beim ersten Lesen wird der vorhandene Stand
  uebernommen, ein neuer Konto-Stand dorthin geschrieben. Weicht der Konto-Stand ab (anderes Geraet) oder wurde er
  im Konto geloescht, startet vorlagen.js die Sektion neu (shopify:section:load an der Wurzel, wie im Theme-Editor)
  und zeigt ihn - nur solange auf der Seite noch nichts eingegeben wurde. Vor dem ersten Abgleich speichert die
  Bruecke nur Eingaben (sofort, als Mikrotask vor jeder Antwort des Kontos), blosses Blaettern wartet auf das Konto;
  eine fruehe Eingabe bleibt stehen und geht hinauf, der Speicher von vorlagen.js folgt dem Formular. "Eingaben
  loeschen" (nach Rueckfrage von vorlagen.js) loescht auch im Konto. Statuszeile [data-mv-konto-hinweis] im Kopf.
  Ohne MVKonto oder wenn vorlagen.js selbst speichert (kontoSelbst, A-2b) bleibt alles wie bisher.

  Nachtrag F-4 (10.10.2026, _docs/f4-mindestrate.md; Inhaber 09.10.2026 zur Inhaberfrage 311 "Mindestrate 100 EUR im
  Monat - gilt sie fuer alle Geraete und Laufzeiten?": "Das gilt fuer Snackautomaten, ist ok wenn andere guenstiger
  sind."): plan() hebt Leasingraten nur bei Standautomaten auf die Mindestrate an. Die Regel kommt aus dem
  Finanzierungsvergleich (mindestrateFuer() in assets/mv-sortiment.finvergleich.js; unter Node ueber
  kontext.finvergleich, im Browser window.__mvSortiment.finvergleich); Geraet je Standort wie geraetInfo(): Standardgeraet
  aus dem Namen, Katalog-Geraet aus Handle, Titel und Typ des Datenblocks, eigener Preis wie ein Standautomat. Ohne Regel
  (Modul fehlt) gilt die Mindestrate wie bis F-4 fuer alle Geraete. Texte: Annahmen-Zeile Leasing und Hinweis im
  Finanzierungsplan nennen die Mindestrate fuer Standautomaten.
*/
/* Nachtrag F-5 (03.11.2026, _docs/f5-mindestrate.md; Inhaber 12.10.2026 zur Inhaberfrage 561: "Nein, der Bank ist das
   egal, koennen auch unter 100 Euro sein"): keine Mindestrate der Partnerbank. plan() hebt keine Leasingrate mehr an
   (p.mindestrate bleibt fuer aeltere Aufrufer eine leere Liste), die Hinweise zur Mindestrate in Zusammenfassung und
   Finanzierungsplan entfallen, die Annahmen-Zeile Leasing nennt "Rate laut Angebot: Nettopreis x 2,09 % je Monat
   (54 Monate, 15 % Restwert), keine Mindestrate". MINDESTRATE (100, Einstiegsangabe der Snackautomaten) bleibt als
   Export. */
(function () {
  'use strict';

  var VERSION = '2026-10-08.2';
  var NBSP = '\u00a0';
  var STRICH = '\u2013';
  var MONATE = 36;
  var MINDESTRATE = 100;          /* Leasing ab 100 EUR / Monat: Einstiegsangabe der Snackautomaten (Faktenliste Nr. 8, Z-06;
                                     global "100"); seit F-5 keine Mindestrate der Partnerbank, plan() hebt nicht an;
                                     F-3a (08.10.2026): Rahmen 2,09 % bei 54 Monaten und 15 % Restwert steht in den Annahmen */
  var VERSANDPAUSCHALE = 200;     /* P-03: Versandpauschale 200 EUR netto je Automat, frei Bordsteinkante (global "200") */
  var WARENEINSATZ_OBEN = 60;     /* Branchenangaben 40 bis 60 % (Recherche 2.2, D5 Abschnitt 4; global "40", "60") */
  var PAKETE = { karte: 475, karteBargeld: 1515 };  /* addons.ts zahlung-nayax-onyx 475; Karte + Bargeld = Nayax Onyx 475 + Currenza C2 550 + ICT XBA 490 (T-7, Inhaber 12.10.2026) */
  var X10_AUFPREIS_PREMIUM = 1050;  /* X10-Faktenbasis: Premium 6.950 minus Lite 5.900 (global "1050") */
  /* Extras laut addons.ts und Matrix 6 (Spiralkonfiguration seit Inhaber 08.10.2026: "nach individuellen Anforderungen", 250) */
  var EXTRAS = [
    { id: 'spiralkonfiguration', titel: 'Spiralkonfiguration nach individuellen Anforderungen', preis: 250, zusatz: 'je Automat', typen: ['snack', 'kombi', 'tisch'] },
    { id: 'dcm5', titel: 'Altersverifikation ICT DCM5', preis: 490, zusatz: 'nur mit Kartenpaket', typen: ['snack', 'kombi', 'tisch', 'micro-market'] },
    { id: 'befestigung', titel: 'Boden- oder Wandbefestigung', preis: 79.9, zusatz: 'je Kit', typen: ['snack', 'kombi', 'getraenke', 'tiefkuehl'] }
  ];
  var OHNE_BARGELD = ['kaffee', 'tisch'];   /* pakete.ts: Kaffee und Tischgeraete nur Nur Automat und Karte */
  var KAPITEL = ['zusammenfassung', 'vorhaben', 'gruender', 'standorte', 'sortiment', 'angebot', 'markt', 'investition', 'finanzierung', 'abschreibung', 'plan',
    'rentabilitaet', 'liquiditaet', 'risiken', 'meilensteine', 'annahmen', 'unterlagen', 'monatswerte'];
  var KAPITEL_TITEL = {
    zusammenfassung: 'Zusammenfassung', vorhaben: 'Vorhaben', gruender: 'Gr\u00fcnderin oder Gr\u00fcnder', standorte: 'Gesch\u00e4ftsmodell und Standorte',
    sortiment: 'Sortiment und Zahlungsarten', angebot: 'Angebot: Automaten und Ausstattung', markt: 'Markt und Wettbewerb', investition: 'Investitionsplan',
    finanzierung: 'Finanzierungsplan', abschreibung: 'Abschreibung', plan: 'Umsatz- und Kostenplanung', rentabilitaet: 'Rentabilit\u00e4t', liquiditaet: 'Liquidit\u00e4t',
    risiken: 'Risiken und Ma\u00dfnahmen', meilensteine: 'Meilensteine', annahmen: 'Annahmen und Quellen', unterlagen: 'Unterlagen und Pflichten',
    monatswerte: 'Monatswerte \u00fcber 36 Monate'
  };
  var ANHANG = { annahmen: 'A1', unterlagen: 'A2', monatswerte: 'A3' };
  var ICONS = ['automat', 'leasing', 'euro', 'prozent', 'haken', 'kalender'];
  /* Diagramme: viewBox-Breite und Schrift in Einheiten; im Druck >= 11 pt (Rechnung in _docs/db-businessplan.md Abschnitt 5) */
  var DIAGRAMM = { breite: 640, schrift: 15, ringBreite: 240, ringSchrift: 16, ringSumme: 24 };

  var TYP_MARKT = {
    produktion: 'Produktion und Werkstatt: Schicht- und Wochenendbetrieb, kurze Pausen und Zeiten, in denen keine Kantine ge\u00f6ffnet hat.',
    buero: 'B\u00fcro und Verwaltung: Verk\u00e4ufe vor allem an Arbeitstagen, Bedarf in Pausen und am Nachmittag; Wettbewerb durch Kantine, B\u00e4ckerei und Kaffeek\u00fcche.',
    fitness: 'Fitnessstudio: Getr\u00e4nke und Snacks vor und nach dem Training, lange \u00d6ffnungszeiten auch am Wochenende.',
    schule: 'Schule und Hochschule: Verk\u00e4ufe in Pausen und Freistunden, in den Ferien deutlich weniger; Sortiment und Jugendschutz mit dem Tr\u00e4ger abstimmen.',
    klinik: 'Klinik und Pflege: Besch\u00e4ftigte im Schichtdienst sowie Besucherinnen und Besucher, auch abends und am Wochenende.',
    hotel: 'Hotel und Gastgewerbe: G\u00e4ste am Abend und in der Nacht, wenn Bar und Rezeption geschlossen sind.'
  };
  var RISIKO = {
    standort: { titel: 'Standortausfall', massnahme: 'Mehrere Standorte, ma\u00dfvolle Laufzeiten und ein Sonderk\u00fcndigungsrecht bei geringem Umsatz im Aufstellungsvertrag; neue Standorte fr\u00fchzeitig ansprechen.' },
    vandalismus: { titel: 'Vandalismus und Aufbruch', massnahme: 'Gesch\u00fctzter Stellplatz, Befestigung, wenig Bargeld im Ger\u00e4t dank Kartenzahlung, Automatenversicherung.' },
    preise: { titel: 'Preis- und Kosten\u00e4nderungen', massnahme: 'Einkaufspreise regelm\u00e4\u00dfig vergleichen, Verkaufspreise anpassen und am Automaten aktualisieren, Strompauschale oder Z\u00e4hler im Aufstellungsvertrag.' },
    saison: { titel: 'Saison und Anlaufphase', massnahme: 'Liquidit\u00e4tsreserve f\u00fcr die ersten Monate, Sortiment an Jahreszeit und Standort anpassen, Verk\u00e4ufe \u00fcber die Telemetrie verfolgen.' },
    regulierung: { titel: 'Neue Regeln', wirkung: 'Zus\u00e4tzliche Ausstattung oder ein anderes Sortiment, etwa durch neue Regeln f\u00fcr Verpackung, Zahlung oder Jugendschutz.', massnahme: 'Kartenzahlung von Anfang an, Sortiment flexibel halten, \u00c4nderungen im Pflichten-Check verfolgen.' },
    technik: { titel: 'Ausfall von K\u00fchlung oder Zahlungssystem', wirkung: 'Ausfalltage ohne Umsatz und verdorbene Ware.', massnahme: 'Telemetrie mit Alarm, R\u00fccklage f\u00fcr Wartung, Ersatzteile und Service.' },
    wettbewerb: { titel: 'Wettbewerb in der N\u00e4he', wirkung: 'Weniger Verk\u00e4ufe, als der Plan annimmt.', massnahme: 'Sortiment und Zugangszeiten auf die Versorgungsl\u00fccken abstimmen.' }
  };
  var KPI_TEXT = {
    kapitalbedarf: 'Kapitalbedarf mit Gr\u00fcndung und Reserve: ',
    ohneRaten: 'ohne Kredit- und Leasingraten',
    kostendeckung: 'erster Monat mit positivem Ergebnis nach Abschreibung',
    amortisation: 'bis die Investition aus dem laufenden \u00dcberschuss gedeckt ist'
  };
  /* K-A: Platzhalter fuer leere Angaben, eine Form im ganzen Dokument (Wert einer Zeile, kein Satz: ohne Punkt) */
  var OFFEN = 'Noch nicht ausgef\u00fcllt';
  /* K-A: Vorschau im Blatt. Seitenbreite 45rem (Bedarf der breitesten Tabelle im Ausgangszustand: Plan ueber 36
     Monate); Seitenansicht nur bis Faktor 0,8 (Tabellen 12,8 px, Diagrammschrift ab 12,5 px wie Test D von D-B) */
  var VORSCHAU = { seiteRem: 45, faktorMin: 0.8 };
  var HINWEIS_ICON = 'breite';
  var HINWEIS_TEXT = { tabelle: 'Seitlich wischen f\u00fcr alle Spalten', diagramm: 'Diagramm seitlich wischen' };

  /* ------------------------------------------------------------------ Hilfen */

  function vorlagenVon(kontext) {
    var k = kontext || {};
    if (k.vorlagen && typeof k.vorlagen.rechnePlan === 'function') return k.vorlagen;
    var mv = typeof window !== 'undefined' ? window.__mvSortiment : null;
    if (mv && mv.vorlagen && typeof mv.vorlagen.rechnePlan === 'function') return mv.vorlagen;
    throw new Error('rechnePlan() aus assets/mv-sortiment.vorlagen.js fehlt');
  }

  function txt(x) {
    return x === null || x === undefined ? '' : String(x).replace(/\s+/g, ' ').trim();
  }

  function istJa(x) {
    return x === true || x === 'true' || x === '1' || x === 1 || x === 'on';
  }

  /* wie zahl() in vorlagen.js: "2,50", "2.5", "1.234,5", "1.234" */
  function zahl(wert) {
    if (typeof wert === 'number') return isFinite(wert) ? wert : NaN;
    if (wert === null || wert === undefined || typeof wert === 'boolean') return NaN;
    var s = String(wert).replace(/[\s\u00a0\u20ac%]/g, '');
    if (!s) return NaN;
    var minus = /^[-\u2212]/.test(s);
    if (minus) s = s.slice(1);
    if (s.indexOf(',') !== -1) s = s.replace(/\./g, '').replace(',', '.');
    else if (/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/\./g, '');
    if (!/^\d+(\.\d+)?$/.test(s)) return NaN;
    var n = parseFloat(s);
    return minus ? -n : n;
  }

  function anzahl(n, eins, mehr) {
    return n === 1 ? '1 ' + eins : n + ' ' + mehr;
  }

  function zweistellig(n) {
    return (n < 10 ? '0' : '') + n;
  }

  /* Datum TT.MM.JJJJ (Deckblatt und Fusszeile des Generators) */
  function heute(d) {
    var x = d instanceof Date && !isNaN(d.getTime()) ? d : new Date();
    return zweistellig(x.getDate()) + '.' + zweistellig(x.getMonth() + 1) + '.' + x.getFullYear();
  }

  function aufzaehlung(teile) {
    var l = teile.filter(function (t) { return !!t; });
    if (l.length < 2) return l.join('');
    return l.slice(0, -1).join(', ') + ' und ' + l[l.length - 1];
  }

  /* CSS-Zeichenkette fuer content: (Kopf- und Fusszeile); spitze Klammern maskiert, damit kein Tag den Stilblock schliesst */
  function cssText(s) {
    return '"' + String(s).replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/[\r\n\f]+/g, ' ').replace(/</g, '\\3C ').replace(/>/g, '\\3E ') + '"';
  }

  /* ------------------------------------------------------------------ Rechnung */

  /* Plan wie bisher (rechnePlan aus assets/mv-sortiment.vorlagen.js). F-5 (03.11.2026): keine Mindestrate der Partnerbank -
     Leasingraten rechnen wie eingegeben, nichts wird angehoben; p.mindestrate bleibt fuer aeltere Aufrufer eine leere Liste */
  function plan(werte, kontext) {
    var k = kontext || {};
    var V = vorlagenVon(k);
    var w = V.mischeFlach(V.planStandard(k.daten || null), werte);
    var p = V.rechnePlan(w, k);
    p.mindestrate = [];
    p.eingaben = w;
    return p;
  }

  var SUMMEN = ['umsatzBrutto', 'umsatzNetto', 'ware', 'karte', 'karteFix', 'karteVar', 'miete', 'mieteFest', 'mieteVar', 'grundkosten', 'leasing', 'weitere', 'gruendung',
    'afa', 'zinsen', 'tilgung', 'investition', 'einzahlung', 'saldo', 'ergebnis', 'verkaeufe', 'betrieb', 'kosten', 'db', 'fix', 'vorAfa', 'kapitaldienst'];

  function periode(monate, von, bis) {
    var o = { von: von, bis: bis };
    SUMMEN.forEach(function (f) { o[f] = 0; });
    for (var m = von; m <= bis; m++) SUMMEN.forEach(function (f) { o[f] += monate[m - 1][f]; });
    o.kontostand = monate[bis - 1].kontostand;
    return o;
  }

  function anlage(name, start, betrag, afaMonate) {
    var monatlich = betrag / afaMonate;
    var jahre = [0, 0, 0];
    for (var m = start; m <= MONATE && m < start + afaMonate; m++) jahre[Math.floor((m - 1) / 12)] += monatlich;
    return { name: name, start: start, betrag: betrag, monatlich: monatlich, jahre: jahre, rest: betrag - jahre[0] - jahre[1] - jahre[2] };
  }

  /* Abrechnung des fertigen Plans: alles aus den Monatswerten von rechnePlan() */
  function auswertung(p) {
    var a = p.annahmen;
    var kf = isFinite(a.karteFix) ? a.karteFix : 0;
    var fixMiete = a.miete === 'fix';
    var monate = p.monate.map(function (z) {
      var verkaeufe = 0;
      p.standorte.forEach(function (s) { if (s.aktiv && z.monat >= s.start) verkaeufe += s.verkaeufe * s.tage; });
      var karteFix = kf * z.standorte;
      var o = {
        monat: z.monat, umsatzBrutto: z.umsatzBrutto, umsatzNetto: z.umsatzNetto, ware: z.ware, karte: z.karte, karteFix: karteFix, karteVar: z.karte - karteFix,
        miete: z.miete, mieteFest: fixMiete ? z.miete : 0, mieteVar: fixMiete ? 0 : z.miete, grundkosten: z.grundkosten, leasing: z.leasing, weitere: z.weitere,
        gruendung: z.gruendung, afa: z.afa, zinsen: z.zinsen, tilgung: z.tilgung, investition: z.investition, einzahlung: z.einzahlungFinanzierung, saldo: z.saldo,
        kontostand: z.kontostand, ergebnis: z.ergebnis, standorte: z.standorte, verkaeufe: verkaeufe
      };
      o.betrieb = o.karte + o.miete + o.grundkosten + o.leasing + o.weitere + o.gruendung;
      o.kosten = o.umsatzNetto - o.ergebnis;
      o.db = o.umsatzNetto - o.ware - o.karteVar - o.mieteVar;
      o.fix = o.grundkosten + o.karteFix + o.mieteFest + o.leasing + o.weitere + o.gruendung;
      o.vorAfa = o.db - o.fix;
      o.kapitaldienst = o.zinsen + o.tilgung + o.leasing;
      return o;
    });
    var jahre = [periode(monate, 1, 12), periode(monate, 13, 24), periode(monate, 25, 36)];
    var gesamt = periode(monate, 1, MONATE);
    var struktur = [
      { id: 'ware', name: 'Wareneinsatz', reihe: 1, wert: gesamt.ware },
      { id: 'miete', name: 'Standortmiete', reihe: 2, wert: gesamt.miete },
      { id: 'grundkosten', name: 'Grundkosten', reihe: 3, wert: gesamt.grundkosten },
      { id: 'karte', name: 'Kartenzahlung', reihe: 4, wert: gesamt.karte },
      { id: 'geraet', name: 'Ger\u00e4t und Finanzierung', reihe: 5, wert: gesamt.afa + gesamt.leasing + gesamt.zinsen },
      { id: 'weitere', name: 'Weitere Kosten und Gr\u00fcndung', reihe: 6, wert: gesamt.weitere + gesamt.gruendung }
    ];
    var summeKosten = struktur.reduce(function (s, t) { return s + Math.max(0, t.wert); }, 0);
    struktur.forEach(function (t) { t.anteil = summeKosten > 0 ? Math.max(0, t.wert) / summeKosten : 0; });
    var d = p.daten || {};
    var anlagen = [];
    p.standorte.forEach(function (s) {
      if (s.finanzierung === 'kauf' && s.aktiv && s.kosten > 0) anlagen.push(anlage(s.geraet + ', ' + s.name, s.start, s.kosten, p.afaMonate));
    });
    if (p.zubehoer > 0) anlagen.push(anlage(txt(d.investition && d.investition.zubehoerText) || 'Zahlungsmodule und Zubeh\u00f6r', 1, p.zubehoer, p.afaMonate));
    var leasing = [];
    p.standorte.forEach(function (s, i) {
      if (s.finanzierung === 'kauf' || !s.aktiv) return;
      var preis = zahl(((d.standorte || [])[i] || {}).geraetPreis);
      preis = isFinite(preis) && preis > 0 ? preis : 0;
      leasing.push({ nr: s.nr, name: s.name, geraet: s.geraet, weg: s.finanzierung, rate: s.rate, laufzeit: s.laufzeit, summe: s.rate * s.laufzeit, preis: preis,
        gleichstand: preis > 0 && s.rate > 0 ? Math.ceil(preis / s.rate - 1e-9) : null });
    });
    var ersteRate = null;
    var ersteRateMonat = null;
    for (var m = 0; m < MONATE; m++) {
      if (monate[m].tilgung > 0) {
        ersteRateMonat = m + 1;
        ersteRate = monate[m].tilgung + monate[m].zinsen;
        break;
      }
    }
    var getilgt = 0;
    var restschuld = jahre.map(function (j) { getilgt += j.tilgung; return p.kredit.betrag - getilgt; });
    var rateMax = 0;
    monate.forEach(function (x) { if (x.kapitaldienst > rateMax) rateMax = x.kapitaldienst; });
    var kb = p.kennzahlen.kapitalbedarf;
    return {
      monate: monate, jahre: jahre, gesamt: gesamt, kostenstruktur: struktur, summeKosten: summeKosten, anlagen: anlagen, leasing: leasing,
      kredit: { ersteRate: ersteRate, ersteRateMonat: ersteRateMonat, tilgungsrate: p.kredit.betrag > 0 ? p.kredit.betrag / (p.kredit.laufzeit - p.kredit.tilgungsfrei) : 0, restschuld: restschuld },
      rateMax: rateMax,
      dbJeVerkauf: jahre[2].verkaeufe > 0 ? jahre[2].db / jahre[2].verkaeufe : null,
      umsatzrendite: jahre.map(function (j) { return j.umsatzNetto > 0 ? j.ergebnis / j.umsatzNetto : null; }),
      kapitalrendite: jahre.map(function (j) { return kb > 0 ? j.ergebnis / kb : null; })
    };
  }

  /* ------------------------------------------------------------------ Bausteine */

  function absatz(text) {
    return { art: 'absatz', text: text, nr: '' };
  }

  function liste(punkte) {
    return { art: 'liste', punkte: punkte };
  }

  function angaben(id, punkte) {
    return { art: 'bp-angaben', id: id, punkte: punkte };
  }

  function zeile(zellen, roh, art) {
    return { art: art || '', zellen: zellen, roh: roh || [] };
  }

  function tabelle(id, titel, kopf, zeilen, zahlen) {
    return { art: 'bp-tabelle', id: id, titel: titel, kopf: kopf, zeilen: zeilen, zahlen: zahlen || [] };
  }

  function verweis(id, href, linkText, text) {
    return { art: 'bp-verweis', id: id, href: href, linkText: linkText, text: text };
  }

  /* Geraeteart fuer Angebot und Herkunft des Preises: x10-lite, x10-premium, katalog (mit Typ), standard, eigen */
  function geraetInfo(wahl, daten, V) {
    var w = String(wahl || 'standard');
    if (w === 'eigen') return { art: 'eigen', typ: '' };
    if (w === 'standard') {
      var g = V.geraetAus(daten);
      if (/x10/i.test(g.name)) return { art: /premium/i.test(g.name) ? 'x10-premium' : 'x10-lite', typ: '', standard: true, preis: g.preis };
      return { art: 'standard', typ: '', standard: true, preis: g.preis };
    }
    var t = w.split(':');
    var liste2 = (daten && daten.geraete) || [];
    for (var i = 0; i < liste2.length; i++) {
      var x = liste2[i];
      if (!x || x.handle !== t[0]) continue;
      var v = (x.varianten || []).filter(function (y) { return String(y.id) === t[1]; })[0];
      var preis = v && typeof v.preis === 'number' ? v.preis / 100 : NaN;
      var typ = txt(x.typ).toLowerCase();
      if (/^x10-/.test(x.handle)) return { art: v && /premium/i.test(v.titel || '') ? 'x10-premium' : 'x10-lite', typ: typ, preis: preis };
      return { art: 'katalog', typ: typ, preis: preis };
    }
    return { art: 'eigen', typ: '' };
  }

  function zahlungText(info) {
    if (info.art === 'x10-lite') return 'Kartenterminal Nayax Onyx ab Werk: kontaktlos mit Kredit- und Debitkarten sowie mobil mit dem Smartphone; Bargeld und Alterspr\u00fcfung auf Anfrage nachr\u00fcstbar.';
    if (info.art === 'x10-premium') return 'Alle vier Zahlungsmodule ab Werk: Kartenterminal Nayax Onyx, M\u00fcnzwechsler Currenza C\u00b2, Scheinleser ICT XBA und Altersverifikation ICT DCM5.';
    if (info.art === 'katalog') return 'Zahlung als Paket nach Wahl, etwa das Komplettpaket Karte.';
    return 'Zahlungssysteme laut Ihrem Angebot.';
  }

  /* ------------------------------------------------------------------ Dokument */

  function dokument(werte, kontext) {
    var k = kontext || {};
    var V = vorlagenVon(k);
    var p = k.plan || plan(werte, k);
    var a = auswertung(p);
    var d = p.daten;
    var t = V.kontextTexte(k, 'businessplan');
    var daten = k.daten || null;
    var kz = p.kennzahlen;
    var j = a.jahre;
    var an = p.annahmen;
    var euro = function (n, s) { return V.euro(n, s); };
    var prozent = V.prozent;
    var zt = V.zahlText;
    var pct = function (x) { return x === null || !isFinite(x) ? STRICH : prozent(Math.round(x * 1000) / 10); };
    var offen = function (x) { return txt(x) || OFFEN; };
    var hinweis = function (text) { return { art: 'hinweis', text: text, label: V.TEXTE.hinweis }; };
    var datum = txt(k.datum) || t.stand;
    var name = txt(d.vorhaben.name);
    var ust = p.ust;
    var umsatzWort = ust ? 'Umsatz netto' : 'Umsatz';
    var aktiv = p.standorte.filter(function (s) { return s.aktiv; });
    var gekauft = aktiv.filter(function (s) { return s.finanzierung === 'kauf'; });
    var geleast = aktiv.filter(function (s) { return s.finanzierung !== 'kauf'; });
    var infos = p.standorte.map(function (s, i) { return geraetInfo(((d.standorte || [])[i] || {}).geraet, daten, V); });
    var afaJ = V.afaJahreAus(daten);
    var fixMiete = an.miete === 'fix';
    var mieteText = fixMiete ? euro(an.mieteFix) + ' je Standort und Monat' : prozent(an.mieteProzent) + (ust ? ' des Nettoumsatzes' : ' des Umsatzes');
    var kapitel = {};

    /* Perioden der Tabellen: Jahr 1 je Monat, Jahre 2 und 3 je Quartal, Jahressummen, Summe 36 Monate */
    var perioden = [];
    for (var m1 = 1; m1 <= 12; m1++) perioden.push({ text: 'Monat ' + m1, von: m1, bis: m1, art: '' });
    perioden.push({ text: 'Summe Jahr 1', von: 1, bis: 12, art: 'summe' });
    [2, 3].forEach(function (jahr) {
      for (var q = 0; q < 4; q++) {
        var von = (jahr - 1) * 12 + q * 3 + 1;
        perioden.push({ text: 'Monate ' + von + STRICH + (von + 2), von: von, bis: von + 2, art: 'zwischen' });
      }
      perioden.push({ text: 'Summe Jahr ' + jahr, von: (jahr - 1) * 12 + 1, bis: jahr * 12, art: 'summe' });
    });
    perioden.push({ text: 'Summe 36 Monate', von: 1, bis: MONATE, art: 'summe' });
    perioden.forEach(function (x) { x.werte = periode(a.monate, x.von, x.bis); });

    /* ---------- Deckblatt */
    var standortListe = p.standorte.map(function (s) { return s.name + ' (' + V.TYP_NAME[s.typ] + ')'; });
    var standorteText = standortListe.length > 3
      ? standortListe.slice(0, 3).join('; ') + ' und ' + (standortListe.length - 3 === 1 ? '1 weiterer Standort' : (standortListe.length - 3) + ' weitere Standorte')
      : standortListe.join('; ');
    var geraeteZahl = {};
    var geraeteFolge = [];
    p.standorte.forEach(function (s) {
      if (!geraeteZahl[s.geraet]) { geraeteZahl[s.geraet] = 0; geraeteFolge.push(s.geraet); }
      geraeteZahl[s.geraet] += 1;
    });
    var geraeteText = geraeteFolge.map(function (g) { return geraeteZahl[g] > 1 ? geraeteZahl[g] + ' \u00d7 ' + g : g; }).join(', ');
    /* Betreiber: Name, Rechtsform und Erwerb mit Komma; ohne Namen steht der Platzhalter, ein Mittelpunkt trennt ihn
       von der Rechtsform (K-A, vorher "Noch nicht ausgefuellt., Einzelunternehmen") */
    var betreiberName = txt(d.gruender.name);
    var betreiber = [V.RECHTSFORM[d.gruender.rechtsform] || V.RECHTSFORM.einzel];
    if (d.gruender.erwerb === 'neben') betreiber.push('im Nebenerwerb');
    var deckblatt = {
      art: 'bp-deckblatt', lead: txt(d.vorhaben.beschreibung), kopfzeile: name || betreiberName || V.TEXTE.titel.businessplan, fusszeile: 'Erstellt am ' + datum,
      punkte: [
        { label: 'Vorhaben', wert: offen(name) },
        { label: 'Betreiber', wert: betreiberName ? [betreiberName].concat(betreiber).join(', ') : OFFEN + ' \u00b7 ' + betreiber.join(', ') },
        { label: 'Standorte', wert: standorteText || OFFEN },
        { label: 'Automaten', wert: geraeteText || OFFEN },
        { label: 'Geplanter Start', wert: offen(d.vorhaben.start) },
        { label: 'Planungszeitraum', wert: '36 Monate ab dem ersten Startmonat' },
        { label: 'Datum', wert: datum },
        { label: 'Stand der Annahmen', wert: t.stand }
      ]
    };

    /* ---------- 1 Zusammenfassung */
    var finTeile = [];
    if (p.eigenkapital > 0) finTeile.push('Eigenkapital ' + euro(p.eigenkapital));
    if (p.kredit.betrag > 0) finTeile.push('Kredit ' + euro(p.kredit.betrag));
    if (geleast.length) finTeile.push('Leasing oder Miete f\u00fcr ' + anzahl(geleast.length, 'Automaten', 'Automaten'));
    var satz = [];
    satz.push((name || 'Das Vorhaben') + ': ' + (aktiv.length ? anzahl(aktiv.length, 'Automat', 'Automaten') + ' an ' + anzahl(aktiv.length, 'Standort', 'Standorten')
      : 'noch kein Standort mit vollst\u00e4ndigen Angaben') + (txt(d.vorhaben.start) ? ', geplanter Start ' + txt(d.vorhaben.start) : '') + '.');
    satz.push('Investition ' + euro(kz.investitionen) + ', Kapitalbedarf mit Gr\u00fcndung und Reserve ' + euro(kz.kapitalbedarf) + ', ' +
      (finTeile.length ? 'finanziert mit ' + aufzaehlung(finTeile) : 'noch ohne Finanzierung') + '.');
    satz.push('Nach den Annahmen liegt der ' + umsatzWort + ' im ersten Jahr bei ' + euro(j[0].umsatzNetto) + ' und das Ergebnis vor Steuern bei ' + euro(j[0].ergebnis) +
      ', im dritten Jahr bei ' + euro(j[2].umsatzNetto) + ' und ' + euro(j[2].ergebnis) + '.');
    var deckSatz = kz.positivAb ? 'Ab Monat ' + kz.positivAb + ' deckt der Umsatz alle Kosten einschlie\u00dflich Abschreibung' : 'Innerhalb von 36 Monaten deckt kein Monat alle Kosten einschlie\u00dflich Abschreibung';
    var amoSatz = kz.investitionen > 0
      ? (kz.gedecktAb ? 'nach ' + anzahl(kz.gedecktAb, 'Monat', 'Monaten') + ' ist die Investition aus dem laufenden \u00dcberschuss gedeckt.' : 'die Investition ist nach 36 Monaten noch nicht aus dem laufenden \u00dcberschuss gedeckt.')
      : 'gekaufte Automaten gibt es nicht, die Raten stehen im Finanzierungsplan.';
    satz.push(deckSatz + '; ' + amoSatz);
    var kpis = { art: 'bp-kpis', werte: [
      { id: 'investition', icon: 'automat', label: 'Investition', wert: euro(kz.investitionen), text: KPI_TEXT.kapitalbedarf + euro(kz.kapitalbedarf) },
      { id: 'finanzierung', icon: 'leasing', label: 'Finanzierung', wert: euro(kz.finanzierung),
        text: (a.rateMax > 0 ? 'Raten bis ' + euro(a.rateMax) + ' pro Monat' : KPI_TEXT.ohneRaten) + (kz.deckung < 0 ? ' \u00b7 Finanzierungsl\u00fccke ' + euro(-kz.deckung) : '') },
      { id: 'umsatz', icon: 'euro', label: umsatzWort + ' im ersten Jahr', wert: euro(j[0].umsatzNetto), text: 'Jahr 2: ' + euro(j[1].umsatzNetto) + ' \u00b7 Jahr 3: ' + euro(j[2].umsatzNetto) },
      { id: 'ueberschuss', icon: 'prozent', label: '\u00dcberschuss vor Steuern im ersten Jahr', wert: euro(j[0].ergebnis), text: 'Jahr 2: ' + euro(j[1].ergebnis) + ' \u00b7 Jahr 3: ' + euro(j[2].ergebnis) },
      { id: 'kostendeckung', icon: 'haken', label: 'Kostendeckung', wert: kz.positivAb ? 'ab Monat ' + kz.positivAb : 'nicht in 36 Monaten', text: KPI_TEXT.kostendeckung },
      { id: 'amortisation', icon: 'kalender', label: 'Amortisation', wert: kz.gedecktAb ? anzahl(kz.gedecktAb, 'Monat', 'Monate') : (kz.investitionen > 0 ? 'mehr als 36 Monate' : STRICH), text: KPI_TEXT.amortisation }
    ] };
    var jahreDia = { art: 'bp-diagramm', id: 'jahre', typ: 'balken-jahre', titel: 'Umsatz, Kosten und Ergebnis je Jahr', tabelle: 'rentabilitaet',
      gruppen: ['Jahr 1', 'Jahr 2', 'Jahr 3'],
      reihen: [
        { reihe: 1, name: umsatzWort, werte: j.map(function (y) { return y.umsatzNetto; }) },
        { reihe: 2, name: 'Kosten gesamt', werte: j.map(function (y) { return y.kosten; }) },
        { reihe: 3, name: 'Ergebnis vor Steuern', werte: j.map(function (y) { return y.ergebnis; }) }
      ],
      beschreibung: j.map(function (y, i) { return 'Jahr ' + (i + 1) + ': ' + umsatzWort + ' ' + euro(y.umsatzNetto) + ', Kosten ' + euro(y.kosten) + ', Ergebnis ' + euro(y.ergebnis); }).join('; ') + '.',
      text: 'Kosten gesamt mit Wareneinsatz, Abschreibung und Zinsen; die Werte je Jahr stehen in der Rentabilit\u00e4tsvorschau.' };
    kapitel.zusammenfassung = [absatz(satz.join(' ')), kpis, jahreDia]
      .concat(p.hinweise.map(hinweis));

    /* ---------- 2 Vorhaben, 3 Gruenderin oder Gruender */
    kapitel.vorhaben = [angaben('vorhaben', [
      { label: 'Name des Vorhabens', wert: offen(name) },
      { label: 'Kurzbeschreibung', wert: offen(d.vorhaben.beschreibung) },
      { label: 'Ziele f\u00fcr die ersten drei Jahre', wert: offen(d.vorhaben.ziel) },
      { label: 'Geplanter Start', wert: offen(d.vorhaben.start) }
    ])];
    kapitel.gruender = [angaben('gruender', [
      { label: 'Name', wert: offen(d.gruender.name) },
      { label: 'Erfahrung und Kenntnisse', wert: offen(d.gruender.qualifikation) },
      { label: 'Zeitlicher Rahmen', wert: d.gruender.erwerb === 'neben' ? 'Nebenerwerb (beim ERP-Gr\u00fcnderkredit StartGeld ebenfalls f\u00f6rderf\u00e4hig)' : 'Haupterwerb' },
      { label: 'Rechtsform', wert: V.RECHTSFORM[d.gruender.rechtsform] || V.RECHTSFORM.einzel },
      { label: 'Umsatzsteuer', wert: ust ? 'Regelbesteuerung mit Vorsteuerabzug' : 'Kleinunternehmer nach \u00a7 19 UStG ohne Vorsteuerabzug' }
    ])];

    /* ---------- 4 Geschaeftsmodell und Standorte */
    var standortZeilen = p.standorte.map(function (s) {
      return zeile([s.name, V.TYP_NAME[s.typ], 'Monat ' + s.start, isFinite(s.verkaeufe) ? zt(s.verkaeufe) : STRICH, isFinite(s.preis) ? euro(s.preis, 2) : STRICH,
        isFinite(s.tage) ? zt(s.tage) : STRICH, s.r ? euro(s.r.netto) : STRICH, s.schwelle ? 'ca. ' + zt(Math.ceil(s.schwelle)) + ' Verk\u00e4ufen pro Tag' : STRICH],
      [null, null, s.start, s.verkaeufe, s.preis, s.tage, s.r ? s.r.netto : null, s.schwelle]);
    });
    kapitel.standorte = [
      absatz('Gesch\u00e4ftsmodell: Sie betreiben die Automaten selbst \u2013 Sie w\u00e4hlen Sortiment und Preise, bef\u00fcllen und warten die Ger\u00e4te und rechnen mit dem Standortgeber ab. ' +
        'Einnahmen sind die Verk\u00e4ufe am Automaten; der Standortgeber erh\u00e4lt als Standortmiete ' + mieteText + '.'),
      absatz('Wie viele Verk\u00e4ufe ein Standort tr\u00e4gt, h\u00e4ngt von der Zahl der Personen vor Ort, ihrer Aufenthaltsdauer, den Zugangszeiten und dem Angebot in der N\u00e4he ab. ' +
        'Der Plan rechnet je Standort mit Ihren Annahmen; vorbelegt sind die Werte des Rechenbeispiels f\u00fcr den Standorttyp.'),
      tabelle('standorte', 'Standorte', ['Standort', 'Standorttyp', 'Start', 'Verk\u00e4ufe pro Tag', '\u00d8-Preis brutto', 'Verkaufstage im Monat', umsatzWort + ' im Monat', 'Kostendeckend ab'],
        standortZeilen, [3, 4, 5, 6])
    ];
    p.standorte.forEach(function (s) {
      if (s.aktiv && s.schwelle && s.verkaeufe < s.schwelle) {
        kapitel.standorte.push(hinweis('\u201e' + s.name + '\u201c: Ihre Annahme von ' + zt(s.verkaeufe) + ' Verk\u00e4ufen pro Tag liegt unter der Kostendeckung von ca. ' + zt(Math.ceil(s.schwelle)) + '.'));
      }
      if (s.r && s.start > MONATE) kapitel.standorte.push(hinweis('\u201e' + s.name + '\u201c startet nach Monat 36 und z\u00e4hlt im Plan nicht.'));
    });

    /* ---------- 5 Sortiment und Zahlungsarten */
    kapitel.sortiment = [
      angaben('sortiment', [
        { label: 'Schwerpunkt', wert: V.SCHWERPUNKT[d.sortiment.schwerpunkt] || V.SCHWERPUNKT.kombi },
        { label: 'Sortiment', wert: offen(d.sortiment.beschreibung) },
        { label: 'Preisstrategie', wert: offen(d.sortiment.preise) },
        { label: 'Mehrwertsteuer', wert: ust ? 'im Mittel ' + prozent(an.mwst) + ' (7 % f\u00fcr Snacks, 19 % f\u00fcr Getr\u00e4nke)' : 'keine (Kleinunternehmer)' }
      ]),
      absatz('Zahlungsarten: Kartenzahlung kontaktlos mit Karte und Smartphone, je nach Ausstattung auch M\u00fcnzen und Scheine. Der Plan rechnet mit ' + prozent(an.kartenanteil) +
        ' Kartenanteil und Kartengeb\u00fchren von ' + euro(an.karteFix) + ' je Automat und Monat plus ' + prozent(an.karteProzent) +
        ' auf den Kartenumsatz \u2013 Beispielwerte, nicht die Konditionen Ihres Zahlungsanbieters.'),
      absatz(ust ? 'Preise am Automaten sind Endpreise einschlie\u00dflich Umsatzsteuer; Pfand steht getrennt daneben.' : 'Als Kleinunternehmer weisen Sie keine Umsatzsteuer aus; Pfand steht getrennt neben dem Preis.')
    ];

    /* ---------- 6 Angebot */
    var angebotZeilen = [];
    var arten = {};
    var katalogTypen = [];
    p.standorte.forEach(function (s, i) {
      if (!s.aktiv) return;
      var info = infos[i];
      arten[info.art] = true;
      if (info.art === 'katalog' && katalogTypen.indexOf(info.typ) === -1) katalogTypen.push(info.typ);
      var betrag = s.finanzierung === 'kauf' ? euro(s.kosten) : euro(s.rate) + ' pro Monat \u00fcber ' + anzahl(s.laufzeit, 'Monat', 'Monate');
      angebotZeilen.push(zeile([s.name, s.geraet, V.FINANZIERUNG_NAME[s.finanzierung], betrag, zahlungText(info)], [null, null, null, s.finanzierung === 'kauf' ? s.kosten : s.rate, null]));
    });
    kapitel.angebot = [absatz('Je Standort ist ein Automat vorgesehen; Kaufpreise ' + (ust ? 'netto' : 'brutto') + ' laut Shop oder Ihrer Angabe, Raten laut Angebot.')];
    if (angebotZeilen.length) kapitel.angebot.push(tabelle('angebot', 'Automaten im Plan', ['Standort', 'Automat', 'Weg', 'Betrag', 'Zahlung'], angebotZeilen, [3]));
    if (arten['x10-lite'] || arten['x10-premium']) {
      kapitel.angebot.push(absatz('X10 Dual Screen: Lieferung in 8 Werktagen ab Lager; Befestigung und Online-Einweisung inklusive.' +
        (arten['x10-lite'] ? ' Die Ausstattung Premium mit M\u00fcnzwechsler, Scheinleser und Altersverifikation kostet ' + euro(X10_AUFPREIS_PREMIUM) + ' netto mehr als Lite.' : '')));
    }
    if (arten.katalog) {
      var mitBargeld = katalogTypen.some(function (x) { return OHNE_BARGELD.indexOf(x) === -1; });
      kapitel.angebot.push(absatz('SandenVendo-Automaten: Die Zahlung w\u00e4hlen Sie als Paket \u2013 Komplettpaket Karte mit Kartenterminal Nayax Onyx (' + euro(PAKETE.karte) +
        ' netto inklusive Einbau)' + (mitBargeld ? ' oder bei Standger\u00e4ten Karte + Bargeld mit M\u00fcnzwechsler und Scheinleser (' + euro(PAKETE.karteBargeld) + ' netto)' : '') +
        '. Lieferzeit ca. 4 Wochen.'));
      var extras = EXTRAS.filter(function (e) { return katalogTypen.some(function (x) { return e.typen.indexOf(x) !== -1; }); }).map(function (e) {
        return e.titel + ': ' + euro(e.preis, e.preis % 1 ? 2 : 0) + ' netto, ' + e.zusatz;
      });
      extras.push('Aufstellung am Standort und individuelle Folierung: auf Anfrage, Preis im Angebot');
      kapitel.angebot.push(liste(extras));
    }
    if (arten.eigen || arten.standard) kapitel.angebot.push(absatz('Weitere Ger\u00e4te: Ausstattung und Zahlung laut Ihrem Angebot.'));
    kapitel.angebot.push(absatz('Lieferung: Speditionsversand innerhalb Deutschlands, Versandpauschale ' + euro(VERSANDPAUSCHALE) + ' netto je Automat, frei Bordsteinkante.'));
    kapitel.angebot.push(hinweis('Pakete, Extras und Lieferung z\u00e4hlen nur zum Kapitalbedarf, wenn Sie sie im Schritt Investition eintragen: unter Zubeh\u00f6r und Zahlungssysteme oder unter Gr\u00fcndungskosten.'));

    /* ---------- 7 Markt und Wettbewerb: neutrale Textbausteine ohne Marktzahlen */
    var typen = [];
    p.standorte.forEach(function (s) { if (typen.indexOf(s.typ) === -1) typen.push(s.typ); });
    kapitel.markt = [absatz('Markt: Verpflegungsautomaten versorgen Besch\u00e4ftigte, G\u00e4ste und Besucher dort, wo Kantine, Kiosk oder Supermarkt fehlen, geschlossen oder weit entfernt sind. ' +
      'Entscheidend sind die Zahl der Personen vor Ort, ihre Aufenthaltsdauer, die Zugangszeiten und das Angebot in der N\u00e4he.')];
    if (typen.length) kapitel.markt.push(liste(typen.map(function (x) { return TYP_MARKT[x]; }).filter(Boolean)));
    kapitel.markt.push(absatz('Wettbewerb am Standort: Kantine, Kiosk, B\u00e4ckerei, Supermarkt oder Tankstelle in der N\u00e4he und ihre \u00d6ffnungszeiten. Ihr Angebot dagegen: Verf\u00fcgbarkeit rund um die Uhr, ' +
      'Kartenzahlung und ein Sortiment, das zum Standort passt.' + (istJa(d.risiken && d.risiken.wettbewerb) ? ' Diesen Wettbewerb sehen Sie als Risiko; die Gegenma\u00dfnahmen stehen unter Risiken und Ma\u00dfnahmen.' : '')));
    kapitel.markt.push(absatz('Standortgeber: Der Automat versorgt Besch\u00e4ftigte oder G\u00e4ste ohne eigenen Aufwand des Standortgebers; Standortmiete, Strom, Zugang und Laufzeit regelt der Aufstellungsvertrag.'));

    /* ---------- 8 Investitionsplan */
    var kleinZusatz = ust ? '' : ' zuz\u00fcglich 19 % Umsatzsteuer (ohne Vorsteuerabzug)';
    var invZeilen = [];
    p.standorte.forEach(function (s, i) {
      if (!s.aktiv || s.finanzierung !== 'kauf') return;
      var info = infos[i];
      var preis = zahl(((d.standorte || [])[i] || {}).geraetPreis);
      var herkunft = 'Ihre Angabe';
      if (info.standard && Math.abs(preis - info.preis) < 0.005) herkunft = 'Preis laut Shop';
      else if (!info.standard && isFinite(info.preis) && Math.abs(preis - info.preis) < 0.005) herkunft = 'Katalogpreis';
      invZeilen.push(zeile(['Automat ' + s.geraet + ', ' + s.name, herkunft + kleinZusatz, 'Monat ' + s.start, euro(s.kosten)], [null, null, s.start, s.kosten]));
    });
    var zubText = txt(d.investition.zubehoerText);
    var x10Lite = gekauft.some(function (s) { return infos[p.standorte.indexOf(s)].art === 'x10-lite'; });
    invZeilen.push(zeile(['Zahlungsmodule und Zubeh\u00f6r' + (zubText ? ': ' + zubText : ''), 'Ihre Angabe' + kleinZusatz + (p.zubehoer > 0 || !x10Lite ? '' : '; beim X10 Dual Screen Lite ist das Kartenterminal enthalten'),
      'Monat 1', euro(p.zubehoer)], [null, null, 1, p.zubehoer]));
    invZeilen.push(zeile(['Lieferung und Aufstellung', 'nicht im Betrag: Versandpauschale ' + euro(VERSANDPAUSCHALE) + ' netto je Automat, Aufstellung laut Angebot', STRICH, STRICH], [null, null, null, null]));
    var ersterMonat = null;
    for (var mm = 0; mm < MONATE; mm++) if (a.monate[mm].standorte > 0) { ersterMonat = mm + 1; break; }
    invZeilen.push(zeile(['Erstbef\u00fcllung', ersterMonat ? 'im Wareneinsatz des ersten Betriebsmonats (Monat ' + ersterMonat + ': ' + euro(a.monate[ersterMonat - 1].ware) + ')' : 'im Wareneinsatz des ersten Betriebsmonats',
      STRICH, STRICH], [null, null, null, null]));
    invZeilen.push(zeile(['Gr\u00fcndungskosten', 'Ihre Angabe', 'Monat 1', euro(p.gruendung)], [null, null, 1, p.gruendung]));
    invZeilen.push(zeile(['Liquidit\u00e4tsreserve', 'Ihre Angabe', STRICH, euro(p.reserve)], [null, null, null, p.reserve]));
    invZeilen.push(zeile(['Kapitalbedarf', '', '', euro(kz.kapitalbedarf)], [null, null, null, kz.kapitalbedarf], 'summe'));
    kapitel.investition = [
      absatz('Der Kapitalbedarf umfasst die gekauften Automaten, Zahlungsmodule und Zubeh\u00f6r, die Gr\u00fcndungskosten und eine Liquidit\u00e4tsreserve. ' +
        (ust ? 'Betr\u00e4ge netto, weil Sie die Vorsteuer erstattet bekommen.' : 'Betr\u00e4ge brutto, weil Sie als Kleinunternehmer keine Vorsteuer erstattet bekommen.')),
      tabelle('investition', 'Investitionsplan', ['Position', 'Grundlage', 'Monat', 'Betrag'], invZeilen, [3])
    ];
    if (gekauft.length) {
      kapitel.investition.push(hinweis('Lieferung: ' + (gekauft.length === 1 ? 'F\u00fcr den gekauften Automaten fallen ' + euro(VERSANDPAUSCHALE) + ' netto'
        : 'F\u00fcr ' + gekauft.length + ' gekaufte Automaten fallen ' + gekauft.length + ' \u00d7 ' + euro(VERSANDPAUSCHALE) + ' = ' + euro(gekauft.length * VERSANDPAUSCHALE) + ' netto') +
        ' Versandpauschale an (frei Bordsteinkante); sind sie nicht in den Gr\u00fcndungskosten enthalten, tragen Sie sie dort ein.'));
    }
    var svOhneZahlung = gekauft.some(function (s) { return infos[p.standorte.indexOf(s)].art === 'katalog'; }) && !(p.zubehoer > 0);
    if (svOhneZahlung) {
      kapitel.investition.push(hinweis('Zahlungsmodule: Bei SandenVendo-Automaten ist die Zahlung nicht im Ger\u00e4tepreis enthalten \u2013 etwa das Komplettpaket Karte mit ' + euro(PAKETE.karte) +
        ' netto je Automat. Tragen Sie Pakete und Extras unter Zubeh\u00f6r und Zahlungssysteme ein.'));
    }
    if (geleast.length) kapitel.investition.push(absatz('Geleaste oder gemietete Automaten sind keine Investition; ihre Raten stehen im Finanzierungsplan.'));

    /* ---------- 9 Finanzierungsplan */
    var kr = p.kredit;
    var finZeilen = [
      zeile(['Eigenkapital', euro(p.eigenkapital), STRICH, STRICH], [null, p.eigenkapital, null, null]),
      zeile(['Kredit' + (txt(d.finanzierung.geber) ? ' (' + txt(d.finanzierung.geber) + ')' : ''), euro(kr.betrag),
        kr.betrag > 0 && a.kredit.ersteRate !== null ? 'ab Monat ' + a.kredit.ersteRateMonat + ': ' + euro(a.kredit.ersteRate) : STRICH,
        kr.betrag > 0 ? kr.laufzeit + ' Monate' + (kr.tilgungsfrei > 0 ? ', davon ' + kr.tilgungsfrei + ' tilgungsfrei' : '') : STRICH], [null, kr.betrag, a.kredit.ersteRate, kr.betrag > 0 ? kr.laufzeit : null]),
      zeile(['Summe der Finanzierung', euro(kz.finanzierung), '', ''], [null, kz.finanzierung, null, null], 'summe'),
      zeile(['Kapitalbedarf', euro(kz.kapitalbedarf), '', ''], [null, kz.kapitalbedarf, null, null]),
      zeile([kz.deckung >= 0 ? 'Puffer' : 'Finanzierungsl\u00fccke', euro(Math.abs(kz.deckung)), '', ''], [null, Math.abs(kz.deckung), null, null], 'summe')
    ];
    kapitel.finanzierung = [
      absatz('Mittelherkunft: Eigenkapital und Kredit decken den Kapitalbedarf; Leasing und Miete ersetzen den Kauf einzelner Automaten durch Monatsraten.'),
      tabelle('finanzierung', 'Finanzierungsplan', ['Quelle', 'Betrag', 'Rate pro Monat', 'Laufzeit'], finZeilen, [1])
    ];
    if (kz.deckung < 0) kapitel.finanzierung.push(hinweis('Finanzierungsl\u00fccke von ' + euro(-kz.deckung) + ': Erh\u00f6hen Sie Eigenkapital oder Kredit, senken Sie die Reserve oder verschieben Sie Investitionen.'));
    if (kr.betrag > 0) {
      kapitel.finanzierung.push(absatz('Kredit' + (txt(d.finanzierung.geber) ? ' von ' + txt(d.finanzierung.geber) : '') + ' \u00fcber ' + euro(kr.betrag) + ', Laufzeit ' + kr.laufzeit + ' Monate, davon ' +
        kr.tilgungsfrei + ' tilgungsfrei; ' + (kr.zins !== null ? 'Zinssatz ' + prozent(kr.zins) + ' pro Jahr (Ihre Angabe)' : 'Zinssatz noch nicht angegeben') + '. Tilgung in gleichen Raten von ' +
        euro(a.kredit.tilgungsrate) + ' ab Monat ' + (kr.tilgungsfrei + 1) + ', Zinsen auf die Restschuld; Restschuld nach 36 Monaten ' + euro(kr.rest) + '.'));
    }
    if (a.leasing.length) {
      kapitel.finanzierung.push(tabelle('leasing', 'Leasing und Miete', ['Automat und Standort', 'Weg', 'Rate pro Monat', 'Laufzeit', 'Summe der Raten', 'Kaufpreis erreicht'],
        a.leasing.map(function (x) {
          var gleich = x.gleichstand === null ? STRICH : (x.gleichstand <= x.laufzeit ? 'nach ' + anzahl(x.gleichstand, 'Monat', 'Monaten') : 'nicht in der Laufzeit');
          return zeile([x.geraet + ', ' + x.name, V.FINANZIERUNG_NAME[x.weg], euro(x.rate), anzahl(x.laufzeit, 'Monat', 'Monate'), euro(x.summe), gleich], [null, null, x.rate, x.laufzeit, x.summe, x.gleichstand]);
        }), [2, 4]));
    }
    if (a.rateMax > 0) {
      var kdZeilen = [
        zeile(['Zinsen'].concat(j.map(function (y) { return euro(y.zinsen); })), [null].concat(j.map(function (y) { return y.zinsen; }))),
        zeile(['Tilgung'].concat(j.map(function (y) { return euro(y.tilgung); })), [null].concat(j.map(function (y) { return y.tilgung; }))),
        zeile(['Leasing- und Mietraten'].concat(j.map(function (y) { return euro(y.leasing); })), [null].concat(j.map(function (y) { return y.leasing; }))),
        zeile(['Kapitaldienst'].concat(j.map(function (y) { return euro(y.kapitaldienst); })), [null].concat(j.map(function (y) { return y.kapitaldienst; })), 'summe')
      ];
      if (kr.betrag > 0) kdZeilen.push(zeile(['Restschuld am Jahresende'].concat(a.kredit.restschuld.map(function (r) { return euro(r); })), [null].concat(a.kredit.restschuld)));
      kapitel.finanzierung.push(tabelle('kapitaldienst', 'Kapitaldienst', ['Position', 'Jahr 1', 'Jahr 2', 'Jahr 3'], kdZeilen, [1, 2, 3]));
    }
    kapitel.finanzierung.push(absatz('F\u00f6rderung: F\u00fcr Gr\u00fcndungen gibt es den ERP-Gr\u00fcnderkredit StartGeld der KfW \u00fcber die Hausbank, beantragt vor Beginn des Vorhabens und auch im Nebenerwerb m\u00f6glich ' +
      '(Merkblatt 067, Stand 18.06.2026). Wer aus der Arbeitslosigkeit gr\u00fcndet, kann bei der Agentur f\u00fcr Arbeit einen Gr\u00fcndungszuschuss beantragen (\u00a7\u00a7 93, 94 SGB III; Ermessensleistung).'));

    /* ---------- 10 Abschreibung */
    if (a.anlagen.length) {
      var summeBetrag = a.anlagen.reduce(function (s, x) { return s + x.betrag; }, 0);
      var summeRest = a.anlagen.reduce(function (s, x) { return s + x.rest; }, 0);
      kapitel.abschreibung = [
        absatz('Abschreibung: linear \u00fcber ' + zt(p.afaJahre) + ' Jahre \u2013 Vorschlag laut AfA-Tabelle je Ger\u00e4tetyp: Warenautomaten wie Snack- und Kombiautomaten ' + zt(afaJ.waren) +
          ' Jahre, reine Getr\u00e4nkeautomaten ' + zt(afaJ.getraenke) + ' Jahre (amtliche AfA-Tabelle f\u00fcr allgemein verwendbare Anlageg\u00fcter, 7.4.2 und 7.4.1), von Ihnen \u00e4nderbar; ' +
          'ob ein Kombiautomat als Waren- oder Getr\u00e4nkeautomat gilt, kl\u00e4rt Ihr Steuerberater.'),
        tabelle('abschreibung', 'Abschreibung je Anlagegut', ['Anlagegut', 'Anschaffung', 'Betrag', 'Jahr 1', 'Jahr 2', 'Jahr 3', 'Restbuchwert nach 36 Monaten'],
          a.anlagen.map(function (x) {
            return zeile([x.name, 'Monat ' + x.start, euro(x.betrag), euro(x.jahre[0]), euro(x.jahre[1]), euro(x.jahre[2]), euro(x.rest)], [null, x.start, x.betrag, x.jahre[0], x.jahre[1], x.jahre[2], x.rest]);
          }).concat([zeile(['Summe', '', euro(summeBetrag), euro(p.jahre[0].afa), euro(p.jahre[1].afa), euro(p.jahre[2].afa), euro(summeRest)],
            [null, null, summeBetrag, p.jahre[0].afa, p.jahre[1].afa, p.jahre[2].afa, summeRest], 'summe')]), [2, 3, 4, 5, 6]),
        absatz('Die Abschreibung mindert das Ergebnis, kostet aber kein Geld: Im Liquidit\u00e4tsplan steht stattdessen der Kaufpreis im Monat der Anschaffung. Nicht gerechnet sind eine degressive ' +
          'Abschreibung und der Investitionsabzugsbetrag \u2013 beides kl\u00e4rt Ihr Steuerberater.' + (ust ? '' : ' Als Kleinunternehmer schreiben Sie den Bruttopreis ab, weil Sie keine Vorsteuer erstattet bekommen.'))
      ];
    } else {
      kapitel.abschreibung = [absatz('Keine gekauften Automaten: Leasing- und Mietraten sind Betriebsausgaben, eine Abschreibung entf\u00e4llt.')];
    }

    /* ---------- 11 Umsatz- und Kostenplanung */
    var erstesJahr = a.monate.slice(0, 12);
    var spanne = function (f) {
      var w = erstesJahr.map(function (x) { return x[f]; });
      return euro(Math.min.apply(null, w)) + ' und ' + euro(Math.max.apply(null, w));
    };
    kapitel.plan = [
      absatz('Jahr 1 steht Monat f\u00fcr Monat, die Jahre 2 und 3 je Quartal; Summenzeilen fassen jedes Jahr und die 36 Monate zusammen. Betriebskosten sind Kartengeb\u00fchren, Standortmiete, ' +
        'Grundkosten, Leasing- und Mietraten, weitere Kosten und Gr\u00fcndungskosten.'),
      { art: 'bp-diagramm', id: 'monate', typ: 'balken-monate', titel: umsatzWort + ' und Kosten je Monat im ersten Jahr', tabelle: 'plan',
        gruppen: erstesJahr.map(function (x) { return String(x.monat); }),
        reihen: [
          { reihe: 1, name: umsatzWort, werte: erstesJahr.map(function (x) { return x.umsatzNetto; }) },
          { reihe: 2, name: 'Kosten gesamt', werte: erstesJahr.map(function (x) { return x.kosten; }) }
        ],
        beschreibung: umsatzWort + ' je Monat zwischen ' + spanne('umsatzNetto') + ', Kosten zwischen ' + spanne('kosten') + '; Ergebnis im ersten Jahr ' + euro(j[0].ergebnis) + '.',
        text: 'Kosten gesamt mit Wareneinsatz, Abschreibung und Zinsen; die Werte stehen in der Tabelle darunter.' },
      tabelle('plan', 'Umsatz- und Kostenplan \u00fcber 36 Monate', ['Zeitraum', umsatzWort, 'Wareneinsatz', 'Betriebskosten', 'Abschreibung', 'Zinsen', 'Ergebnis vor Steuern'],
        perioden.map(function (x) {
          var v = x.werte;
          var roh = [null, v.umsatzNetto, v.ware, v.betrieb, v.afa, v.zinsen, v.ergebnis];
          return zeile([x.text].concat(roh.slice(1).map(function (n) { return euro(n); })), roh, x.art);
        }), [1, 2, 3, 4, 5, 6])
    ];

    /* ---------- 12 Rentabilitaet */
    var rz = [];
    var reihe = function (label, f, vorzeichen, art) {
      var roh = j.map(function (y) { return vorzeichen * y[f]; });
      rz.push(zeile([label].concat(roh.map(function (n) { return euro(n); })), [null].concat(roh), art));
    };
    var quote = function (label, werte2) { rz.push(zeile([label].concat(werte2.map(pct)), [null].concat(werte2))); };
    if (ust) reihe('Umsatz brutto', 'umsatzBrutto', 1);
    reihe(umsatzWort, 'umsatzNetto', 1);
    reihe('Wareneinsatz', 'ware', -1);
    reihe('Kartengeb\u00fchren, umsatzabh\u00e4ngig', 'karteVar', -1);
    if (!fixMiete) reihe('Standortmiete, umsatzabh\u00e4ngig', 'mieteVar', -1);
    reihe('Deckungsbeitrag', 'db', 1, 'summe');
    quote('Deckungsbeitrag in % vom Umsatz', j.map(function (y) { return y.umsatzNetto > 0 ? y.db / y.umsatzNetto : null; }));
    reihe('Grundkosten', 'grundkosten', -1);
    reihe('Grundgeb\u00fchr Kartenzahlung', 'karteFix', -1);
    if (fixMiete) reihe('Standortmiete, fest', 'mieteFest', -1);
    reihe('Leasing und Miete', 'leasing', -1);
    reihe('Weitere Kosten', 'weitere', -1);
    reihe('Gr\u00fcndungskosten', 'gruendung', -1);
    reihe('Ergebnis vor Abschreibung und Zinsen', 'vorAfa', 1, 'summe');
    reihe('Abschreibung', 'afa', -1);
    reihe('Zinsen', 'zinsen', -1);
    reihe('Ergebnis vor Steuern', 'ergebnis', 1, 'summe');
    quote('Umsatzrendite', a.umsatzrendite);
    quote('Rendite auf den Kapitalbedarf', a.kapitalrendite);
    kapitel.rentabilitaet = [
      absatz('Die Rentabilit\u00e4tsvorschau f\u00fchrt vom Umsatz \u00fcber den Deckungsbeitrag zum Ergebnis vor Steuern. Der Deckungsbeitrag ist, was nach Wareneinsatz und umsatzabh\u00e4ngigen Kosten bleibt; ' +
        'er tr\u00e4gt die festen Kosten.' + (a.dbJeVerkauf !== null ? ' Je Verkauf bleiben im dritten Jahr im Mittel ' + euro(a.dbJeVerkauf, 2) + ', die festen Kosten liegen bei ' +
        euro(j[2].fix / 12) + ' im Monat.' : '') + ' Renditen sind Rechenwerte aus Ihren Annahmen, keine Zusage.'),
      tabelle('rentabilitaet', 'Rentabilit\u00e4tsvorschau', ['Position', 'Jahr 1', 'Jahr 2', 'Jahr 3'], rz, [1, 2, 3]),
      { art: 'bp-diagramm', id: 'kostenstruktur', typ: 'ring', titel: 'Kostenstruktur \u00fcber 36 Monate', tabelle: 'rentabilitaet', summe: a.summeKosten,
        teile: a.kostenstruktur.map(function (x) { return { id: x.id, reihe: x.reihe, name: x.name, wert: x.wert, anteil: x.anteil }; }),
        beschreibung: a.kostenstruktur.filter(function (x) { return x.wert > 0; }).map(function (x) { return x.name + ' ' + euro(x.wert) + ' (' + pct(x.anteil) + ')'; }).join(', ') +
          '; zusammen ' + euro(a.summeKosten) + '.',
        text: 'Anteile an allen Kosten der 36 Monate einschlie\u00dflich Abschreibung; Betr\u00e4ge und Anteile stehen in der Legende.' }
    ];

    /* ---------- 13 Liquiditaet */
    var tief = kz.tiefpunkt;
    var marken = [];
    if (kz.positivAb) marken.push({ id: 'kostendeckung', monat: kz.positivAb, text: 'Kostendeckung ab Monat ' + kz.positivAb });
    if (kz.gedecktAb) marken.push({ id: 'amortisation', monat: kz.gedecktAb, text: 'Investition gedeckt: Monat ' + kz.gedecktAb });
    marken.push({ id: 'tiefpunkt', monat: tief.monat, text: 'Tiefpunkt: ' + euro(tief.wert) });
    kapitel.liquiditaet = [
      absatz('Einzahlungen sind der ' + (ust ? 'Nettoumsatz' : 'Umsatz') + ' und die Finanzierung, Auszahlungen die laufenden Kosten, Investitionen, Zinsen und Tilgung; die Abschreibung kostet kein Geld. ' +
        'Der Kontostand ist in Monat ' + tief.monat + ' am niedrigsten (' + euro(tief.wert) + ') und liegt am Ende der drei Jahre bei ' + euro(j[0].kontostand) + ', ' + euro(j[1].kontostand) + ' und ' +
        euro(j[2].kontostand) + '. ' + (kz.positivAb ? 'Kostendeckung ab Monat ' + kz.positivAb + ': ab dann deckt der Umsatz alle Kosten einschlie\u00dflich Abschreibung.' : 'Eine Kostendeckung erreicht der Plan in 36 Monaten nicht.') +
        (kz.gedecktAb ? ' Die Investition ist in Monat ' + kz.gedecktAb + ' aus dem laufenden \u00dcberschuss gedeckt.' : '')),
      { art: 'bp-diagramm', id: 'liquiditaet', typ: 'linie', titel: 'Kontostand je Monat \u00fcber 36 Monate', tabelle: 'liquiditaet',
        werte: a.monate.map(function (x) { return x.kontostand; }), marken: marken,
        beschreibung: 'Kontostand nach Monat 1: ' + euro(a.monate[0].kontostand) + '; Tiefpunkt in Monat ' + tief.monat + ' mit ' + euro(tief.wert) + '; am Ende von Jahr 1 ' + euro(j[0].kontostand) +
          ', Jahr 2 ' + euro(j[1].kontostand) + ', Jahr 3 ' + euro(j[2].kontostand) + (kz.positivAb ? '; Kostendeckung ab Monat ' + kz.positivAb : '') +
          (kz.gedecktAb ? '; Investition gedeckt in Monat ' + kz.gedecktAb : '') + '.',
        text: 'Kontostand am Monatsende mit Finanzierung; markiert sind Kostendeckung, Investition gedeckt und Tiefpunkt. Die Werte stehen in der Tabelle darunter und im Anhang.' },
      tabelle('liquiditaet', 'Liquidit\u00e4tsplan', ['Zeitraum', 'Einzahlungen aus Umsatz', 'Einzahlungen aus Finanzierung', 'Auszahlungen', 'Saldo', 'Kontostand am Ende'],
        perioden.map(function (x) {
          var v = x.werte;
          var aus = v.umsatzNetto + v.einzahlung - v.saldo;
          var roh = [null, v.umsatzNetto, v.einzahlung, aus, v.saldo, v.kontostand];
          return zeile([x.text].concat(roh.slice(1).map(function (n) { return euro(n); })), roh, x.art);
        }), [1, 2, 3, 4, 5])
    ];
    if (tief.wert < 0) kapitel.liquiditaet.push(hinweis('Der Kontostand wird negativ. Erh\u00f6hen Sie Eigenkapital, Kredit oder Reserve oder verschieben Sie Investitionen.'));

    /* ---------- 14 Risiken und Massnahmen */
    var mitR = p.standorte.filter(function (s) { return s.aktiv; });
    var gross = mitR.length ? mitR.reduce(function (x, y) { return y.r.ueberschuss > x.r.ueberschuss ? y : x; }) : null;
    var risikoZeilen = [];
    var risiko = function (id, wirkung) { risikoZeilen.push(zeile([RISIKO[id].titel, wirkung, RISIKO[id].massnahme])); };
    var gewaehlt = function (id) { return istJa(d.risiken && d.risiken[id]); };
    if (gewaehlt('standort')) {
      risiko('standort', mitR.length > 1 ? 'Ohne \u201e' + gross.name + '\u201c fehlen rund ' + euro(gross.r.ueberschuss) + ' \u00dcberschuss im Monat (vor Abschreibung und Raten).'
        : (mitR.length === 1 ? 'F\u00e4llt der einzige Standort weg, entfallen alle Einnahmen; Abschreibung, Raten und Zinsen laufen weiter.' : 'Noch kein Standort mit vollst\u00e4ndigen Angaben.'));
    }
    if (gewaehlt('vandalismus')) risiko('vandalismus', 'Reparatur, Ausfallzeit und Bargeldverlust; der Plan enth\u00e4lt daf\u00fcr nur die R\u00fccklage in den Grundkosten (' + euro(an.grundkosten) + ' je Automat und Monat).');
    var we = an.wareneinsatz;
    var preisWirkung;
    if (isFinite(we) && we < WARENEINSATZ_OBEN) {
      var p60 = V.rechnePlan(V.mischeFlach(p.eingaben || werte, { 'annahmen.wareneinsatz': String(WARENEINSATZ_OBEN) }), k);
      preisWirkung = 'Steigt der Wareneinsatz von ' + prozent(we) + ' auf ' + prozent(WARENEINSATZ_OBEN) + ' (oberes Ende der Branchenangaben), sinkt das Ergebnis im dritten Jahr von ' +
        euro(j[2].ergebnis) + ' auf ' + euro(p60.jahre[2].ergebnis) + '.';
    } else {
      preisWirkung = 'Ihr Wareneinsatz liegt mit ' + prozent(we) + ' bereits am oberen Ende der Branchenangaben (40 bis 60 %).';
    }
    if (gewaehlt('energie')) preisWirkung += ' Strom steckt in den Grundkosten; steigende Energiepreise erh\u00f6hen sie.';
    risiko('preise', preisWirkung);
    var schwellen = mitR.filter(function (s) { return s.schwelle; }).map(function (s) {
      return '\u201e' + s.name + '\u201c ab ca. ' + zt(Math.ceil(s.schwelle)) + ' Verk\u00e4ufen pro Tag (Annahme: ' + zt(s.verkaeufe) + ')';
    });
    risiko('saison', 'Der Plan rechnet ab dem Startmonat mit vollen Verk\u00e4ufen; Ferien, Urlaub und eine Anlaufzeit senken den Umsatz.' + (schwellen.length ? ' Kostendeckend: ' + schwellen.join('; ') + '.' : ''));
    ['regulierung', 'technik', 'wettbewerb'].forEach(function (id) { if (gewaehlt(id)) risiko(id, RISIKO[id].wirkung); });
    kapitel.risiken = [
      absatz('Chancen: Versorgung rund um die Uhr, auch in Schicht- und Wochenendbetrieben; Kartenzahlung ist an Automaten verbreitet; weitere Standorte lassen sich mit demselben Ablauf erschlie\u00dfen.'),
      tabelle('risiken', 'Risiken und Ma\u00dfnahmen', ['Risiko', 'Wirkung im Plan', 'Ma\u00dfnahme'], risikoZeilen, [])
    ];
    if (txt(d.risiken && d.risiken.massnahmen)) kapitel.risiken.push(absatz('Weitere Ma\u00dfnahmen: ' + txt(d.risiken.massnahmen)));

    /* ---------- 15 Meilensteine (wie bisher) */
    var ms = [{ monat: 0, text: 'Vor dem Start: Gewerbe anmelden, steuerliche Erfassung beim Finanzamt, Registrierung bei der Lebensmittel\u00fcberwachung, Aufstellungsvertr\u00e4ge mit den Standortgebern.' }];
    aktiv.forEach(function (s) { ms.push({ monat: s.start, text: 'Monat ' + s.start + ': ' + s.name + ' geht in Betrieb (' + s.geraet + ').' }); });
    if (kz.positivAb) ms.push({ monat: kz.positivAb, text: 'Monat ' + kz.positivAb + ': Monatsergebnis erstmals positiv.' });
    if (kz.gedecktAb) ms.push({ monat: kz.gedecktAb, text: 'Monat ' + kz.gedecktAb + ': Investitionen aus dem laufenden \u00dcberschuss gedeckt.' });
    (d.meilensteine || []).forEach(function (x) {
      var mon = Math.round(zahl(x && x.monat));
      if (txt(x && x.titel)) ms.push({ monat: mon >= 1 ? mon : 0, text: (mon >= 1 ? 'Monat ' + mon + ': ' : '') + txt(x.titel) });
    });
    ms.sort(function (x, y) { return x.monat - y.monat; });
    kapitel.meilensteine = [liste(ms.map(function (x) { return x.text; }))];

    /* ---------- A1 Annahmen und Quellen */
    var kreditWert = kr.betrag > 0 ? (kr.zins !== null ? 'Zinssatz ' + prozent(kr.zins) + ' pro Jahr' : 'Zinssatz nicht angegeben') + ', Laufzeit ' + kr.laufzeit + ' Monate' : 'kein Kredit';
    var annahmen = [
      ['Umsatzsteuer', ust ? 'Regelbesteuerung; Betr\u00e4ge netto, Vorsteuer aus Anschaffungen erstattet' : 'Kleinunternehmer nach \u00a7 19 UStG; Umsatz ohne Abzug, Anschaffungen brutto', 'Ihre Angabe'],
      ['Mehrwertsteuer im Sortiment', 'im Mittel ' + prozent(an.mwst), 'Mischung aus 7 % f\u00fcr Snacks und 19 % f\u00fcr Getr\u00e4nke; Vorschlag wie im Rechenbeispiel \u201eWie rechnet sich das?\u201c'],
      ['Wareneinsatz', prozent(we) + ' des Nettoumsatzes', 'Branchenangaben 40 bis 60 %; Vorschlag wie im Rechenbeispiel'],
      ['Grundkosten', euro(an.grundkosten) + ' je Automat und Monat', 'Strom, Versicherung und R\u00fccklage f\u00fcr Wartung; Vorschlag wie im Rechenbeispiel'],
      ['Kartenzahlung', euro(an.karteFix) + ' je Automat und Monat und ' + prozent(an.karteProzent) + ' auf den Kartenumsatz', 'Beispielwerte, nicht die Konditionen Ihres Zahlungsanbieters'],
      ['Kartenanteil', prozent(an.kartenanteil) + ' des Umsatzes', 'Branchenverband BDV: Anteil der bargeldlosen Transaktionen'],
      ['Standortmiete', mieteText, 'Ihre Vereinbarung im Aufstellungsvertrag; Vorschlag wie im Rechenbeispiel'],
      ['Verk\u00e4ufe, \u00d8-Preis und Verkaufstage', 'je Standort, siehe Gesch\u00e4ftsmodell und Standorte', 'Ihre Annahmen; vorbelegt mit den Werten des Rechenbeispiels je Standorttyp'],
      ['Ger\u00e4tepreise', 'je Automat, siehe Investitionsplan', 'Katalogpreise netto im Shop oder Ihre Angabe'],
      ['Lieferung', 'Versandpauschale ' + euro(VERSANDPAUSCHALE) + ' netto je Automat, frei Bordsteinkante', 'Versandpauschale im Shop; im Kapitalbedarf nur, wenn Sie sie eintragen'],
      ['Leasing', 'Rate laut Angebot: Nettopreis \u00d7 2,09\u00a0% je Monat (54 Monate, 15\u00a0% Restwert), keine Mindestrate', 'Rahmen der Partnerbank: 2,09\u00a0% des Nettopreises je Monat bei 54 Monaten und 15\u00a0% Restwert'],
      ['Kredit', kreditWert, 'Ihre Angabe; Zinsen und F\u00f6rderbedingungen tagesaktuell bei Ihrer Hausbank'],
      ['Abschreibung', 'linear \u00fcber ' + zt(p.afaJahre) + ' Jahre', 'AfA-Tabelle f\u00fcr allgemein verwendbare Anlageg\u00fcter: Warenautomaten ' + zt(afaJ.waren) + ' Jahre (7.4.2), Getr\u00e4nkeautomaten ' + zt(afaJ.getraenke) + ' Jahre (7.4.1)']
    ];
    kapitel.annahmen = [
      tabelle('annahmen', 'Annahmen und Quellen', ['Annahme', 'Wert im Plan', 'Quelle'], annahmen.map(function (x) { return zeile(x); }), []),
      absatz('Nicht enthalten: Einkommen- und Gewerbesteuer, Privatentnahmen, Ihre Arbeitszeit, Saisonschwankungen und eine Anlaufphase, eine degressive Abschreibung und der Investitionsabzugsbetrag.'),
      hinweis('Rechenbeispiel aus Ihren Angaben \u2013 keine Steuer-, Rechts- oder Finanzierungsberatung. Lassen Sie den Plan vor der Vorlage bei Bank oder F\u00f6rderstelle steuerlich pr\u00fcfen.')
    ];

    /* ---------- A2 Unterlagen und Pflichten */
    kapitel.unterlagen = [
      liste(['Lebenslauf und Nachweise Ihrer Kenntnisse', 'Zusagen oder Aufstellungsvertr\u00e4ge der Standortgeber', 'Angebote f\u00fcr Automaten und Zahlungssysteme', 'Angebote f\u00fcr Versicherungen',
        'Gewerbeanmeldung und steuerliche Erfassung', 'Registrierung bei der Lebensmittel\u00fcberwachung', 'Nachweis \u00fcber Ihr Eigenkapital']),
      absatz('Welche Anmeldungen und Pflichten f\u00fcr Ihren Automaten gelten \u2013 Gewerbe, Finanzamt, Lebensmittel\u00fcberwachung, Preisangaben, Pfand und Jugendschutz \u2013, zeigt der Pflichten-Check ' +
        'als pers\u00f6nliche Liste mit Rechtsgrundlage.'),
      verweis('pflichten', '/pages/pflichten-check', 'Pflichten-Check', 'pers\u00f6nliche Liste der Pflichten f\u00fcr Ihren Automaten'),
      verweis('vertrag', '/pages/aufstellungsvertrag', 'Aufstellungsvertrag-Generator', 'Vertrag mit dem Standortgeber als Muster')
    ];

    /* ---------- A3 Monatswerte */
    kapitel.monatswerte = [tabelle('monatswerte', 'Monatswerte \u00fcber 36 Monate', ['Monat', umsatzWort, 'Kosten', 'Ergebnis vor Steuern', 'Saldo', 'Kontostand'],
      a.monate.map(function (x) {
        return zeile(['Monat ' + x.monat, euro(x.umsatzNetto), euro(x.kosten), euro(x.ergebnis), euro(x.saldo), euro(x.kontostand)], [x.monat, x.umsatzNetto, x.kosten, x.ergebnis, x.saldo, x.kontostand]);
      }).concat([zeile(['Summe 36 Monate', euro(a.gesamt.umsatzNetto), euro(a.gesamt.kosten), euro(a.gesamt.ergebnis), euro(a.gesamt.saldo), euro(a.gesamt.kontostand)],
        [null, a.gesamt.umsatzNetto, a.gesamt.kosten, a.gesamt.ergebnis, a.gesamt.saldo, a.gesamt.kontostand], 'summe')]), [1, 2, 3, 4, 5])];

    var nr = 0;
    return {
      werkzeug: 'businessplan',
      version: 2,
      titel: V.TEXTE.titel.businessplan + (name ? ': ' + name : ''),
      untertitel: t.kurz,
      kopf: [deckblatt],
      abschnitte: KAPITEL.map(function (id) {
        if (!ANHANG[id]) nr += 1;
        return { id: id, nr: ANHANG[id] || String(nr), titel: KAPITEL_TITEL[id], bloecke: kapitel[id] };
      }),
      anlagen: [],
      unterschriften: [],
      rechtshinweis: t.rechtshinweis,
      stand: t.stand
    };
  }

  /* ------------------------------------------------------------------ Diagramme: Geometrie (rein) */

  function n1(x) {
    var r = Math.round(x * 10) / 10;
    return String(r === 0 ? 0 : r);
  }

  /* Achse mit runden Schritten 1, 2, 2,5, 5 x 10^k (mindestens 1 EUR), drei bis sieben Marken, schliesst 0 ein */
  function achse(min, max) {
    var lo = Math.min(0, isFinite(min) ? min : 0);
    var hi = Math.max(0, isFinite(max) ? max : 0);
    if (hi - lo < 4) hi = lo + 4;
    var roh = (hi - lo) / 4;
    var p = Math.pow(10, Math.floor(Math.log(roh) / Math.LN10));
    var stufen = [1, 2, 2.5, 5, 10];
    var schritt = 10 * p;
    for (var i = 0; i < stufen.length; i++) {
      if (stufen[i] * p >= roh - 1e-9) {
        schritt = stufen[i] * p;
        break;
      }
    }
    if (schritt < 1) schritt = 1;
    var von = Math.floor(lo / schritt + 1e-9);
    var bis = Math.ceil(hi / schritt - 1e-9);
    var ticks = [];
    for (var n = von; n <= bis; n++) ticks.push(n === 0 ? 0 : n * schritt);
    return { min: von * schritt, max: bis * schritt, schritt: schritt, ticks: ticks };
  }

  /* Saeulen je Monat, gruppiert nach Reihen; abgerundetes Datenende, gerade an der Grundlinie */
  function balkenMonate(reihen) {
    var W = DIAGRAMM.breite;
    var H = 300;
    var L = 84;
    var R = 8;
    var O = 14;
    var U = 62;
    var alle = [];
    reihen.forEach(function (r) { r.werte.forEach(function (v) { alle.push(v); }); });
    var ax = achse(Math.min.apply(null, alle), Math.max.apply(null, alle));
    var plotH = H - O - U;
    var y = function (v) { return O + (ax.max - v) / (ax.max - ax.min) * plotH; };
    var n = reihen.length ? reihen[0].werte.length : 0;
    var gw = (W - L - R) / Math.max(n, 1);
    var k = reihen.length;
    var bw = Math.min(16, (gw - 10 - (k - 1) * 2) / Math.max(k, 1));
    var balken = [];
    var gruppen = [];
    for (var i = 0; i < n; i++) {
      var x0 = L + i * gw + (gw - (k * bw + (k - 1) * 2)) / 2;
      gruppen.push({ text: String(i + 1), x: L + i * gw + gw / 2 });
      for (var r = 0; r < k; r++) {
        var v = reihen[r].werte[i];
        var oben = y(Math.max(v, 0));
        balken.push({ reihe: reihen[r].reihe, name: reihen[r].name, gruppe: i, wert: v, x: x0 + r * (bw + 2), y: oben, b: bw, h: y(Math.min(v, 0)) - oben });
      }
    }
    return { breite: W, hoehe: H, links: L, rechts: W - R, oben: O, unten: H - U, achse: ax, ticks: ax.ticks.map(function (t) { return { wert: t, y: y(t) }; }),
      basis: y(0), balken: balken, gruppen: gruppen };
  }

  /* Waagrechte Balken je Jahr (Umsatz, Kosten, Ergebnis); negative Werte links der Nulllinie */
  function balkenJahre(gruppen, reihen) {
    var W = DIAGRAMM.breite;
    var L = 88;
    var R = 112;
    var O = 8;
    var BH = 20;
    var GL = 22;
    var k = reihen.length;
    var gh = k * BH + (k - 1) * 2;
    var H = O * 2 + gruppen.length * gh + (gruppen.length - 1) * GL;
    var alle = [];
    reihen.forEach(function (r) { r.werte.forEach(function (v) { alle.push(v); }); });
    var min = Math.min.apply(null, alle.concat([0]));
    var max = Math.max.apply(null, alle.concat([0]));
    if (!(max - min > 0)) max = min + 1;
    var skala = (W - L - R) / (max - min);
    var x0 = L - min * skala;
    var balken = [];
    gruppen.forEach(function (g, gi) {
      var gy = O + gi * (gh + GL);
      reihen.forEach(function (r, ri) {
        var v = r.werte[gi];
        var len = Math.abs(v) * skala;
        var yy = gy + ri * (BH + 2);
        balken.push({ reihe: r.reihe, name: r.name, gruppe: gi, wert: v, x: v < 0 ? x0 - len : x0, y: yy, b: len, h: BH, tx: v < 0 ? x0 + 6 : x0 + len + 6, ty: yy + BH / 2 + 5 });
      });
    });
    return { breite: W, hoehe: H, links: L, null: x0, oben: O, unten: H - O, balken: balken,
      gruppen: gruppen.map(function (g, gi) { return { text: g, y: O + gi * (gh + GL) + gh / 2 + 5 }; }) };
  }

  function textBreite(t, fs) {
    return String(t).length * (fs || DIAGRAMM.schrift) * 0.56;
  }

  /* Linie je Monat (Kontostand) mit Achse, Jahresmarken und Ereignissen (Kostendeckung, Investition gedeckt, Tiefpunkt) */
  function linie(werte, marken) {
    var W = DIAGRAMM.breite;
    var H = 330;
    var L = 84;
    var R = 92;
    var O = 52;
    var U = 58;
    var n = werte.length;
    var ax = achse(Math.min.apply(null, werte), Math.max.apply(null, werte));
    var plotW = W - L - R;
    var plotH = H - O - U;
    var x = function (m) { return L + (m - 1) / Math.max(n - 1, 1) * plotW; };
    var y = function (v) { return O + (ax.max - v) / (ax.max - ax.min) * plotH; };
    var punkte = werte.map(function (v, i) { return { monat: i + 1, wert: v, x: x(i + 1), y: y(v) }; });
    var belegt = [-Infinity, -Infinity];
    var ms = (marken || []).filter(function (m) { return m.monat >= 1 && m.monat <= n; }).map(function (m) {
      var px = x(m.monat);
      var py = y(werte[m.monat - 1]);
      var breite = textBreite(m.text);
      if (m.id === 'tiefpunkt') {
        var unten = py + 24 <= H - U - 4;
        var rechts = px + 10 + breite <= W - 4;
        return { id: m.id, monat: m.monat, x: px, y: py, text: m.text, art: 'punkt', tx: rechts ? px + 10 : px - 10, ty: unten ? py + 22 : py - 12, anker: rechts ? 'start' : 'end' };
      }
      var anker = px + 4 + breite <= W - 4 ? 'start' : 'end';
      var anfang = anker === 'start' ? px : px - 4 - breite;
      var reihe = anfang > belegt[0] + 8 ? 0 : 1;
      belegt[reihe] = anker === 'start' ? px + 4 + breite : px;
      return { id: m.id, monat: m.monat, x: px, y: py, text: m.text, art: 'linie', zeile: reihe, tx: anker === 'start' ? px + 4 : px - 4, ty: reihe === 0 ? 20 : 40, anker: anker };
    });
    var jahre = [];
    /* Jahresgrenzen auf den Monatsmarken 12 und 24 (Sichtpruefung: halbe Monate daneben wirkten wie Doppellinien) */
    for (var jj = 0; jj * 12 < n; jj++) {
      var von = Math.max(1, jj * 12);
      var bis = Math.min((jj + 1) * 12, n);
      jahre.push({ text: 'Jahr ' + (jj + 1), x: x((von + bis) / 2), trenner: jj > 0 ? x(jj * 12) : null });
    }
    return { breite: W, hoehe: H, links: L, rechts: W - R, oben: O, unten: H - U, achse: ax, ticks: ax.ticks.map(function (t) { return { wert: t, y: y(t) }; }), null: y(0),
      punkte: punkte, marken: ms, jahre: jahre, monatsMarken: [1, 12, 24, 36].filter(function (m) { return m <= n; }).map(function (m) { return { text: String(m), x: x(m) }; }) };
  }

  function polar(cx, cy, rad, grad) {
    var w = (grad - 90) * Math.PI / 180;
    return n1(cx + rad * Math.cos(w)) + ' ' + n1(cy + rad * Math.sin(w));
  }

  /* Ringsegment von "von" bis "bis" Grad (0 = oben, im Uhrzeigersinn); ein voller Ring als zwei Haelften */
  function sektor(cx, cy, aussen, innen, von, bis) {
    if (bis - von >= 359.999) return sektor(cx, cy, aussen, innen, 0, 180) + ' ' + sektor(cx, cy, aussen, innen, 180, 360);
    var gross = bis - von > 180 ? 1 : 0;
    return 'M' + polar(cx, cy, aussen, von) + ' A' + aussen + ' ' + aussen + ' 0 ' + gross + ' 1 ' + polar(cx, cy, aussen, bis) + ' L' + polar(cx, cy, innen, bis) +
      ' A' + innen + ' ' + innen + ' 0 ' + gross + ' 0 ' + polar(cx, cy, innen, von) + ' Z';
  }

  function ring(teile) {
    var W = DIAGRAMM.ringBreite;
    var c = W / 2;
    var aussen = 112;
    var innen = 74;
    var summe = 0;
    teile.forEach(function (t) { if (t.wert > 0) summe += t.wert; });
    var segmente = [];
    var winkel = 0;
    teile.forEach(function (t) {
      if (!(t.wert > 0) || !(summe > 0)) return;
      var bogen = t.wert / summe * 360;
      segmente.push({ reihe: t.reihe, name: t.name, wert: t.wert, anteil: t.wert / summe, start: winkel, ende: winkel + bogen, pfad: sektor(c, c, aussen, innen, winkel, winkel + bogen) });
      winkel += bogen;
    });
    return { breite: W, hoehe: W, mitte: c, summe: summe, segmente: segmente };
  }

  /* ------------------------------------------------------------------ Ausgabe: Baum -> Text, Markdown, HTML, DOM */

  function el(tag, attr, kinder) {
    return { t: tag, a: attr || {}, k: (kinder || []).filter(function (x) { return x !== null && x !== undefined && x !== ''; }) };
  }

  var SATZ_RE = /(\u00a7\u00a7?|Abs\.|Nr\.|Art\.|Anlage|Satz)[ ](?=\d)/g;
  function satz(t) {
    return String(t).replace(SATZ_RE, '$1' + NBSP);
  }

  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function zuHtml(n) {
    if (typeof n === 'string') return esc(satz(n));
    if (n.icon) return '';
    var a = '';
    Object.keys(n.a).forEach(function (key) {
      var v = n.a[key];
      if (v === null || v === undefined || v === false) return;
      a += v === true ? ' ' + key : ' ' + key + '="' + esc(v) + '"';
    });
    return '<' + n.t + a + '>' + n.k.map(zuHtml).join('') + '</' + n.t + '>';
  }

  function sText(x, y, text, klasse, extra) {
    var attr = { class: klasse, x: n1(x), y: n1(y), 'font-size': String(DIAGRAMM.schrift) };
    var e = extra || {};
    Object.keys(e).forEach(function (key) { attr[key] = e[key]; });
    return el('text', attr, [text]);
  }

  function legende(eintraege, mitWerten) {
    return el('ul', { class: 'mv-bp-legende' + (mitWerten ? ' mv-bp-legende--werte' : ''), role: 'list' }, eintraege.map(function (x) {
      return el('li', { class: 'mv-bp-legende__eintrag' }, [
        el('span', { class: 'mv-bp-legende__marke mv-bp-reihe-' + x.reihe, 'aria-hidden': 'true' }, []),
        el('span', { class: 'mv-bp-legende__name' }, [x.name]),
        mitWerten ? el('span', { class: 'mv-bp-legende__wert' }, [x.wert]) : null,
        mitWerten ? el('span', { class: 'mv-bp-legende__anteil' }, [x.anteil]) : null
      ]);
    }));
  }

  /* Betraege im Diagramm: ganze Euro, Tausenderpunkt, U+00A0 vor dem Eurozeichen (wie vorlagen.js) */
  function euroText(x) {
    var r = Math.round(Math.abs(x));
    var s = String(r).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (x < 0 && r !== 0 ? '\u2212' : '') + s + NBSP + '\u20ac';
  }

  function prozentText(x) {
    var r = Math.round(x * 1000) / 10;
    return String(r).replace('.', ',') + NBSP + '%';
  }

  function saeule(b) {
    var r = Math.min(4, b.b / 2, b.h);
    if (b.wert >= 0) {
      return 'M' + n1(b.x) + ' ' + n1(b.y + b.h) + ' V' + n1(b.y + r) + ' Q' + n1(b.x) + ' ' + n1(b.y) + ' ' + n1(b.x + r) + ' ' + n1(b.y) + ' H' + n1(b.x + b.b - r) +
        ' Q' + n1(b.x + b.b) + ' ' + n1(b.y) + ' ' + n1(b.x + b.b) + ' ' + n1(b.y + r) + ' V' + n1(b.y + b.h) + ' Z';
    }
    return 'M' + n1(b.x) + ' ' + n1(b.y) + ' V' + n1(b.y + b.h - r) + ' Q' + n1(b.x) + ' ' + n1(b.y + b.h) + ' ' + n1(b.x + r) + ' ' + n1(b.y + b.h) + ' H' + n1(b.x + b.b - r) +
      ' Q' + n1(b.x + b.b) + ' ' + n1(b.y + b.h) + ' ' + n1(b.x + b.b) + ' ' + n1(b.y + b.h - r) + ' V' + n1(b.y) + ' Z';
  }

  function balkenQuer(b, nullX) {
    var r = Math.min(4, b.h / 2, b.b);
    if (b.wert >= 0) {
      var e = b.x + b.b;
      return 'M' + n1(nullX) + ' ' + n1(b.y) + ' H' + n1(e - r) + ' Q' + n1(e) + ' ' + n1(b.y) + ' ' + n1(e) + ' ' + n1(b.y + r) + ' V' + n1(b.y + b.h - r) +
        ' Q' + n1(e) + ' ' + n1(b.y + b.h) + ' ' + n1(e - r) + ' ' + n1(b.y + b.h) + ' H' + n1(nullX) + ' Z';
    }
    return 'M' + n1(nullX) + ' ' + n1(b.y) + ' H' + n1(b.x + r) + ' Q' + n1(b.x) + ' ' + n1(b.y) + ' ' + n1(b.x) + ' ' + n1(b.y + r) + ' V' + n1(b.y + b.h - r) +
      ' Q' + n1(b.x) + ' ' + n1(b.y + b.h) + ' ' + n1(b.x + r) + ' ' + n1(b.y + b.h) + ' H' + n1(nullX) + ' Z';
  }

  function svgBaum(b, id) {
    var kinder = [];
    var g;
    if (b.typ === 'balken-monate') {
      g = balkenMonate(b.reihen);
      g.ticks.forEach(function (t) {
        kinder.push(el('line', { class: t.wert === 0 ? 'mv-bp-achse' : 'mv-bp-gitter', x1: n1(g.links), y1: n1(t.y), x2: n1(g.rechts), y2: n1(t.y) }));
        kinder.push(sText(g.links - 8, t.y + 5, euroText(t.wert), 'mv-bp-achse__text', { 'text-anchor': 'end' }));
      });
      g.balken.forEach(function (x) {
        if (x.h < 0.5) return;
        kinder.push(el('path', { class: 'mv-bp-balken mv-bp-reihe-' + x.reihe, d: saeule(x) }, [el('title', {}, ['Monat ' + (x.gruppe + 1) + ': ' + x.name + ' ' + euroText(x.wert)])]));
      });
      g.gruppen.forEach(function (x) { kinder.push(sText(x.x, g.unten + 22, x.text, 'mv-bp-achse__text', { 'text-anchor': 'middle' })); });
      kinder.push(sText(g.links, g.hoehe - 8, 'Monat', 'mv-bp-achse__titel'));
    } else if (b.typ === 'balken-jahre') {
      g = balkenJahre(b.gruppen, b.reihen);
      g.balken.forEach(function (x) {
        if (x.b >= 0.5) kinder.push(el('path', { class: 'mv-bp-balken mv-bp-reihe-' + x.reihe, d: balkenQuer(x, g.null) }, [el('title', {}, [b.gruppen[x.gruppe] + ': ' + x.name + ' ' + euroText(x.wert)])]));
        kinder.push(sText(x.tx, x.ty, euroText(x.wert), 'mv-bp-wert'));
      });
      kinder.push(el('line', { class: 'mv-bp-achse', x1: n1(g.null), y1: n1(g.oben - 4), x2: n1(g.null), y2: n1(g.unten + 4) }));
      g.gruppen.forEach(function (x) { kinder.push(sText(g.links - 14, x.y, x.text, 'mv-bp-gruppe', { 'text-anchor': 'end' })); });
    } else if (b.typ === 'linie') {
      g = linie(b.werte, b.marken);
      g.ticks.forEach(function (t) {
        kinder.push(el('line', { class: t.wert === 0 ? 'mv-bp-achse' : 'mv-bp-gitter', x1: n1(g.links), y1: n1(t.y), x2: n1(g.rechts), y2: n1(t.y) }));
        kinder.push(sText(g.links - 8, t.y + 5, euroText(t.wert), 'mv-bp-achse__text', { 'text-anchor': 'end' }));
      });
      g.jahre.forEach(function (x) {
        if (x.trenner !== null) kinder.push(el('line', { class: 'mv-bp-gitter', x1: n1(x.trenner), y1: n1(g.oben), x2: n1(x.trenner), y2: n1(g.unten) }));
        kinder.push(sText(x.x, g.unten + 42, x.text, 'mv-bp-achse__titel', { 'text-anchor': 'middle' }));
      });
      g.monatsMarken.forEach(function (x) { kinder.push(sText(x.x, g.unten + 20, x.text, 'mv-bp-achse__text', { 'text-anchor': 'middle' })); });
      var pfad = g.punkte.map(function (x, i) { return (i ? 'L' : 'M') + n1(x.x) + ' ' + n1(x.y); }).join(' ');
      var erster = g.punkte[0];
      var letzter = g.punkte[g.punkte.length - 1];
      kinder.push(el('path', { class: 'mv-bp-flaeche mv-bp-reihe-1', d: pfad + ' L' + n1(letzter.x) + ' ' + n1(g.null) + ' L' + n1(erster.x) + ' ' + n1(g.null) + ' Z' }));
      g.marken.forEach(function (x) {
        if (x.art === 'linie') {
          kinder.push(el('line', { class: 'mv-bp-marke', x1: n1(x.x), y1: n1(x.ty + 6), x2: n1(x.x), y2: n1(g.unten) }));
          kinder.push(sText(x.tx, x.ty, x.text, 'mv-bp-marke__text', { 'text-anchor': x.anker }));
        }
      });
      kinder.push(el('path', { class: 'mv-bp-linie mv-bp-reihe-1', d: pfad }));
      g.marken.forEach(function (x) {
        if (x.art === 'punkt') {
          kinder.push(el('circle', { class: 'mv-bp-punkt mv-bp-reihe-1', cx: n1(x.x), cy: n1(x.y), r: '5' }));
          kinder.push(sText(x.tx, x.ty, x.text, 'mv-bp-marke__text', { 'text-anchor': x.anker }));
        }
      });
      kinder.push(sText(letzter.x + 8, letzter.y + 5, euroText(letzter.wert), 'mv-bp-wert'));
      g.punkte.forEach(function (x) {
        kinder.push(el('circle', { class: 'mv-bp-treffer', cx: n1(x.x), cy: n1(x.y), r: '8' }, [el('title', {}, ['Monat ' + x.monat + ': Kontostand ' + euroText(x.wert)])]));
      });
    } else {
      g = ring(b.teile);
      g.segmente.forEach(function (x) {
        kinder.push(el('path', { class: 'mv-bp-segment mv-bp-reihe-' + x.reihe, d: x.pfad }, [el('title', {}, [x.name + ': ' + euroText(x.wert) + ' (' + prozentText(x.anteil) + ')'])]));
      });
      kinder.push(el('text', { class: 'mv-bp-ring__summe', x: n1(g.mitte), y: n1(g.mitte + 2), 'text-anchor': 'middle', 'font-size': String(DIAGRAMM.ringSumme) }, [euroText(g.summe)]));
      kinder.push(el('text', { class: 'mv-bp-ring__text', x: n1(g.mitte), y: n1(g.mitte + 24), 'text-anchor': 'middle', 'font-size': String(DIAGRAMM.ringSchrift) }, ['Kosten gesamt']));
    }
    return el('svg', { class: 'mv-bp-svg', viewBox: '0 0 ' + g.breite + ' ' + g.hoehe, role: 'img', 'aria-labelledby': id + '-t ' + id + '-d' },
      [el('title', { id: id + '-t' }, [b.titel]), el('desc', { id: id + '-d' }, [b.beschreibung])].concat(kinder));
  }

  function diagrammBaum(b, o) {
    var id = (o && o.id ? o.id : 'mv-vorlagen') + '-bp-' + b.id;
    var flaeche = el('div', { class: 'mv-bp-diagramm__flaeche', role: 'region', tabindex: '0', 'aria-label': b.titel }, [svgBaum(b, id)]);
    var inhalt;
    if (b.typ === 'ring') {
      var teile = b.teile.filter(function (x) { return x.wert > 0; }).map(function (x) { return { reihe: x.reihe, name: x.name, wert: euroText(x.wert), anteil: prozentText(x.anteil) }; });
      inhalt = [el('div', { class: 'mv-bp-ring' }, [flaeche, legende(teile, true)])];
    } else if (b.typ === 'linie') {
      inhalt = [flaeche];
    } else {
      inhalt = [legende(b.reihen, false), flaeche];
    }
    return el('figure', { class: 'mv-bp-diagramm mv-bp-diagramm--' + b.typ, 'data-mv-bp-diagramm': b.id },
      [el('figcaption', { class: 'mv-bp-diagramm__titel' }, [b.titel])].concat(inhalt, [el('p', { class: 'mv-bp-diagramm__text' }, [b.text])]));
  }

  function angabenBaum(punkte, zusatz) {
    return el('dl', { class: 'mv-bp-angaben' + (zusatz ? ' ' + zusatz : '') }, punkte.map(function (x) {
      return el('div', { class: 'mv-bp-angaben__zeile' }, [el('dt', { class: 'mv-bp-angaben__label' }, [x.label]), el('dd', { class: 'mv-bp-angaben__wert' }, [x.wert])]);
    }));
  }

  function tabelleBaum(b) {
    var zahl2 = function (i) { return b.zahlen.indexOf(i) !== -1 ? 'mv-vorlagen-dok__zahl' : null; };
    var kopf = el('thead', {}, [el('tr', {}, b.kopf.map(function (x, i) { return el('th', { class: zahl2(i), scope: 'col' }, [x]); }))]);
    var rumpf = el('tbody', {}, b.zeilen.map(function (z) {
      return el('tr', { class: 'mv-bp-tab__zeile' + (z.art ? ' mv-bp-tab__zeile--' + z.art : '') }, z.zellen.map(function (c, i) {
        return i === 0 ? el('th', { class: 'mv-bp-tab__kopf', scope: 'row' }, [c]) : el('td', { class: zahl2(i) }, [c]);
      }));
    }));
    return el('div', { class: 'mv-vorlagen-dok__tabelle mv-bp-tabelle', role: 'region', tabindex: '0', 'aria-label': b.titel || b.kopf.join(', '), 'data-mv-bp-tabelle': b.id },
      [el('table', { class: 'mv-vorlagen-dok__tab mv-bp-tab' }, [b.titel ? el('caption', { class: 'mv-vorlagen-dok__tab-titel' }, [b.titel]) : null, kopf, rumpf])]);
  }

  function baum(b, o) {
    switch (b.art) {
      case 'bp-deckblatt':
        return el('div', { class: 'mv-bp-deckblatt', 'data-mv-bp-kopfzeile': b.kopfzeile, 'data-mv-bp-fusszeile': b.fusszeile },
          [b.lead ? el('p', { class: 'mv-bp-deckblatt__lead' }, [b.lead]) : null, angabenBaum(b.punkte, 'mv-bp-angaben--deckblatt')]);
      case 'bp-angaben':
        return angabenBaum(b.punkte, '');
      case 'bp-kpis':
        return el('ul', { class: 'mv-bp-kpis', role: 'list' }, b.werte.map(function (x) {
          return el('li', { class: 'mv-bp-kpi', 'data-mv-bp-kpi': x.id }, [{ icon: x.icon }, el('span', { class: 'mv-bp-kpi__label' }, [x.label]),
            el('span', { class: 'mv-bp-kpi__wert' }, [x.wert]), x.text ? el('span', { class: 'mv-bp-kpi__text' }, [x.text]) : null]);
        }));
      case 'bp-tabelle':
        return tabelleBaum(b);
      case 'bp-diagramm':
        return diagrammBaum(b, o);
      case 'bp-verweis':
        return el('p', { class: 'mv-bp-verweis' }, [o && o.standalone ? el('span', { class: 'mv-bp-verweis__link' }, [b.linkText]) : el('a', { class: 'mv-bp-verweis__link', href: b.href }, [b.linkText]),
          ' ' + STRICH + ' ' + b.text]);
      default:
        return null;
    }
  }

  function blockText(b) {
    switch (b.art) {
      case 'bp-deckblatt':
        return (b.lead ? [b.lead] : []).concat(b.punkte.map(function (x) { return x.label + ': ' + x.wert; }));
      case 'bp-angaben':
        return b.punkte.map(function (x) { return x.label + ': ' + x.wert; });
      case 'bp-kpis':
        return b.werte.map(function (x) { return x.label + ': ' + x.wert + (x.text ? ' (' + x.text + ')' : ''); });
      case 'bp-tabelle':
        return (b.titel ? [b.titel + ':'] : []).concat([b.kopf.join(' | ')], b.zeilen.map(function (z) { return z.zellen.join(' | '); }));
      case 'bp-diagramm':
        return [b.titel + ': ' + b.beschreibung];
      case 'bp-verweis':
        return [b.linkText + ': ' + b.text];
      default:
        return null;
    }
  }

  function mdZelle(t) {
    return String(t).replace(/\|/g, '\\|');
  }

  function blockMarkdown(b) {
    switch (b.art) {
      case 'bp-deckblatt':
        return (b.lead ? ['_' + b.lead + '_', ''] : []).concat(b.punkte.map(function (x) { return '- **' + x.label + ':** ' + x.wert; }));
      case 'bp-angaben':
        return b.punkte.map(function (x) { return '- **' + x.label + ':** ' + x.wert; });
      case 'bp-kpis':
        return b.werte.map(function (x) { return '- **' + x.label + ':** ' + x.wert + (x.text ? ' ' + STRICH + ' ' + x.text : ''); });
      case 'bp-tabelle': {
        var z = b.titel ? ['**' + b.titel + '**', ''] : [];
        z.push('| ' + b.kopf.map(mdZelle).join(' | ') + ' |');
        z.push('|' + b.kopf.map(function (_, i) { return b.zahlen.indexOf(i) !== -1 ? ' ---: ' : ' --- '; }).join('|') + '|');
        b.zeilen.forEach(function (r) {
          z.push('| ' + r.zellen.map(function (c) {
            var t = mdZelle(c);
            if (!t) return t;
            return r.art === 'summe' ? '**' + t + '**' : (r.art === 'zwischen' ? '_' + t + '_' : t);
          }).join(' | ') + ' |');
        });
        return z;
      }
      case 'bp-diagramm':
        return ['_' + b.titel + ': ' + b.beschreibung + '_'];
      case 'bp-verweis':
        return ['**' + b.linkText + ':** ' + b.text];
      default:
        return null;
    }
  }

  function blockHtml(b, o) {
    var n = baum(b, o || {});
    return n ? zuHtml(n) : null;
  }

  /* DRUCK_CSS Anfang */
  var DRUCK_CSS = [
    '.mv-bp-deckblatt { margin-top: 1rem; }',
    '.mv-bp-deckblatt__lead { margin: 0 0 1rem; font-size: 13pt; line-height: 1.45; color: #283550; }',
    '.mv-bp-angaben { display: grid; grid-template-columns: minmax(8rem, 13rem) 1fr; margin: .5rem 0; border-top: 1px solid #c9d2e3; }',
    '.mv-bp-angaben__zeile { display: contents; }',
    '.mv-bp-angaben__label, .mv-bp-angaben__wert { margin: 0; padding: .35rem .5rem .35rem 0; border-bottom: 1px solid #c9d2e3; }',
    '.mv-bp-angaben__label { font-weight: 700; color: #30405f; }',
    '.mv-bp-kpis { display: grid; grid-template-columns: repeat(3, 1fr); gap: .5rem; margin: .75rem 0; padding: 0; list-style: none; }',
    '.mv-bp-kpi { display: flex; flex-direction: column; gap: .1rem; padding: .55rem .7rem; border: 1px solid #c9d2e3; border-top: 3px solid #4174c0; border-radius: 6px; background: #f4f7fd; }',
    '.mv-bp-kpi__label { font-size: 9pt; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; color: #47546e; }',
    '.mv-bp-kpi__wert { font-size: 16pt; font-weight: 800; color: #283550; }',
    '.mv-bp-kpi__text { font-size: 9pt; color: #47546e; }',
    '.mv-bp-tab th[scope="row"] { background: none; font-weight: 600; white-space: normal; }',
    '.mv-bp-tab thead th { white-space: normal; vertical-align: bottom; }',
    '[data-mv-bp-tabelle="plan"] th[scope="row"], [data-mv-bp-tabelle="liquiditaet"] th[scope="row"], [data-mv-bp-tabelle="monatswerte"] th[scope="row"] { white-space: nowrap; }',
    '.mv-bp-tab__zeile--summe th, .mv-bp-tab__zeile--summe td { font-weight: 800; border-top: 1.5px solid #30405f; background: #f4f7fd; }',
    '.mv-bp-tab__zeile--zwischen th, .mv-bp-tab__zeile--zwischen td { color: #30405f; background: #fbfcfe; }',
    '.mv-bp-diagramm { margin: .9rem 0; break-inside: avoid; }',
    '.mv-bp-diagramm__titel { margin: 0 0 .3rem; font-weight: 700; font-size: 11pt; color: #283550; }',
    '.mv-bp-diagramm__text { margin: .3rem 0 0; font-size: 9pt; color: #47546e; }',
    '.mv-bp-svg { display: block; width: 100%; height: auto; overflow: visible; font-family: inherit; }',
    '.mv-bp-diagramm--ring .mv-bp-svg { width: 64mm; max-width: 100%; }',
    '.mv-bp-ring { display: flex; flex-wrap: wrap; align-items: center; gap: 1rem 2rem; }',
    '.mv-bp-legende { display: flex; flex-wrap: wrap; gap: .25rem 1.25rem; margin: 0 0 .4rem; padding: 0; list-style: none; font-size: 11pt; }',
    '.mv-bp-legende--werte { display: grid; grid-template-columns: auto 1fr auto auto; gap: .3rem .75rem; align-items: center; }',
    '.mv-bp-legende--werte .mv-bp-legende__eintrag { display: contents; }',
    '.mv-bp-legende__eintrag { display: inline-flex; align-items: center; gap: .4rem; }',
    '.mv-bp-legende__marke { display: inline-block; width: .8rem; height: .8rem; border-radius: 2px; background: var(--mv-bp-f); }',
    '.mv-bp-legende__wert, .mv-bp-legende__anteil { text-align: right; font-variant-numeric: tabular-nums; }',
    '.mv-bp-reihe-1 { --mv-bp-f: #2a78d6; } .mv-bp-reihe-2 { --mv-bp-f: #eb6834; } .mv-bp-reihe-3 { --mv-bp-f: #1baf7a; }',
    '.mv-bp-reihe-4 { --mv-bp-f: #eda100; } .mv-bp-reihe-5 { --mv-bp-f: #e87ba4; } .mv-bp-reihe-6 { --mv-bp-f: #008300; }',
    '.mv-bp-balken, .mv-bp-segment, .mv-bp-punkt { fill: var(--mv-bp-f); }',
    '.mv-bp-segment { stroke: #ffffff; stroke-width: 2; }',
    '.mv-bp-punkt { stroke: #ffffff; stroke-width: 2; }',
    '.mv-bp-linie { fill: none; stroke: var(--mv-bp-f); stroke-width: 2; stroke-linejoin: round; stroke-linecap: round; }',
    '.mv-bp-flaeche { fill: var(--mv-bp-f); fill-opacity: .1; }',
    '.mv-bp-treffer { fill: transparent; }',
    '.mv-bp-gitter { stroke: #e3e8f1; stroke-width: 1; }',
    '.mv-bp-achse { stroke: #30405f; stroke-width: 1.5; }',
    '.mv-bp-marke { stroke: #30405f; stroke-width: 1; }',
    '.mv-bp-achse__text, .mv-bp-achse__titel, .mv-bp-ring__text { fill: #47546e; }',
    '.mv-bp-wert, .mv-bp-gruppe, .mv-bp-marke__text, .mv-bp-ring__summe { fill: #283550; font-weight: 700; }',
    '.mv-bp-verweis__link { font-weight: 700; }',
    '@page { size: A4; margin: 22mm 16mm 20mm; }',
    '@media print {',
    '  .mv-bp-kpi, .mv-bp-legende__marke, .mv-bp-tab__zeile--summe th, .mv-bp-tab__zeile--summe td { -webkit-print-color-adjust: exact; print-color-adjust: exact; }',
    '  [data-mv-vorlagen-teil="kopf"] { display: flex; flex-direction: column; align-items: flex-start; gap: 4mm; min-height: 248mm; padding-top: 18mm; border-top: 3mm solid #283550; break-after: page; }',
    '  [data-mv-vorlagen-teil="kopf"] > * { margin: 0; }',
    '  [data-mv-vorlagen-teil="kopf"] > h1 { font-size: 28pt; line-height: 1.12; }',
    '  .mv-bp-deckblatt { display: flex; flex: 1 1 auto; flex-direction: column; align-self: stretch; gap: 6mm; }',
    '  .mv-bp-angaben--deckblatt { margin-top: auto; border-top: 3px solid #4174c0; }',
    '  [data-mv-vorlagen-abschnitt="zusammenfassung"] { break-after: page; }',
    '  [data-mv-vorlagen-abschnitt="annahmen"] { break-before: page; }',
    '  .mv-bp-kpi, .mv-bp-tab__zeile, .mv-bp-angaben, .mv-bp-angaben__zeile, article > footer { break-inside: avoid; }',
    '  .mv-bp-tab > caption { break-after: avoid; }',
    '  .mv-bp-tab tbody tr:nth-child(-n+3), .mv-bp-tab tbody tr:nth-last-child(-n+2) { break-before: avoid; }',
    '}'
  ];
  var DRUCK_BOX = 'font: 9pt "Barlow", "Helvetica Neue", Arial, sans-serif; color: #47546e;';

  /* Druckregeln der HTML-Datei: Kopf- und Fusszeile mit Firmenname und Datum (Seitenraender), Seitenzahl, Deckblatt ohne */
  function druckCss(dok) {
    if (!dok || dok.werkzeug !== 'businessplan' || dok.version !== 2) return '';
    var deck = (dok.kopf || []).filter(function (b) { return b.art === 'bp-deckblatt'; })[0] || {};
    var box = DRUCK_BOX;
    return DRUCK_CSS.concat([
      '@page { @top-left { content: ' + cssText(deck.kopfzeile || 'Businessplan') + '; ' + box + ' } @top-right { content: "Businessplan"; ' + box + ' } ' +
        '@bottom-left { content: ' + cssText(deck.fusszeile || '') + '; ' + box + ' } @bottom-right { content: "Seite " counter(page) " von " counter(pages); ' + box + ' } }',
      '@page :first { @top-left { content: none; } @top-right { content: none; } @bottom-left { content: none; } @bottom-right { content: none; } }'
    ]).join('\n');
  }
  /* DRUCK_CSS Ende */

  /* ------------------------------------------------------------------ Vorschau: Seitenansicht oder Fliessen (K-A, rein) */

  /* verfuegbar: Breite des Dokumentbereichs im Blatt; bedarf: Breite, bei der keine Tabelle und kein Diagramm
     ueberlaeuft; seite: Seitenbreite in px. Seitenansicht = Dokument mindestens so breit wie die Seite und wie der
     Bedarf, verkleinert auf die verfuegbare Breite, solange der Faktor nicht unter VORSCHAU.faktorMin faellt; sonst
     fliesst es in der verfuegbaren Breite (breite Bereiche scrollen mit Hinweis). Ohne Breite (verborgen) nichts. */
  function vorschau(verfuegbar, bedarf, seite) {
    if (!(verfuegbar > 0)) return { seite: false, skala: 1, breite: 0 };
    var breite = Math.max(seite, bedarf);
    var skala = Math.min(1, verfuegbar / breite);
    return skala >= VORSCHAU.faktorMin - 1e-9 ? { seite: true, skala: skala, breite: breite } : { seite: false, skala: 1, breite: verfuegbar };
  }

  /* ------------------------------------------------------------------ Konto (Paket A-2a) */

  var KONTO_WERKZEUG = 'businessplan';

  /* Titel fuer die Uebersicht "Meine Werkzeuge": Name des Vorhabens (hoechstens 120 Zeichen), sonst leer */
  function kontoTitel(werte) {
    var t = txt(werte && werte['vorhaben.name']);
    return t.length > 120 ? t.slice(0, 120) : t;
  }

  /* Stand fuers Konto aus den Feldwerten und dem Schritt (Form wie der Zustand von vorlagen.js plus Titel) */
  function kontoStand(werte, schritt) {
    var w = {};
    var q = werte && typeof werte === 'object' ? werte : {};
    Object.keys(q).forEach(function (k) {
      if (typeof q[k] === 'string' || typeof q[k] === 'boolean') w[k] = q[k];
    });
    var s = { v: 1, werte: w, schritt: typeof schritt === 'string' ? schritt : '' };
    var t = kontoTitel(w);
    if (t) s.titel = t;
    return s;
  }

  /* gleiche flache Werte (Reihenfolge der Schluessel egal) */
  function gleicheWerte(a, b) {
    if (!a || !b) return false;
    var ka = Object.keys(a);
    var kb = Object.keys(b);
    if (ka.length !== kb.length) return false;
    for (var i = 0; i < ka.length; i++) if (!Object.prototype.hasOwnProperty.call(b, ka[i]) || a[ka[i]] !== b[ka[i]]) return false;
    return true;
  }

  /* gleicher Inhalt und gleicher Schritt */
  function gleicherStand(a, b) {
    return !!(a && b && (a.schritt || '') === (b.schritt || '') && gleicheWerte(a.werte, b.werte));
  }

  var api = {
    KONTO_WERKZEUG: KONTO_WERKZEUG, kontoTitel: kontoTitel, kontoStand: kontoStand, gleicheWerte: gleicheWerte, gleicherStand: gleicherStand,
    VERSION: VERSION, MONATE: MONATE, MINDESTRATE: MINDESTRATE, VERSANDPAUSCHALE: VERSANDPAUSCHALE, PAKETE: PAKETE, EXTRAS: EXTRAS, KAPITEL: KAPITEL, ICONS: ICONS,
    DIAGRAMM: DIAGRAMM, OFFEN: OFFEN, VORSCHAU: VORSCHAU, HINWEIS_ICON: HINWEIS_ICON, heute: heute, plan: plan, auswertung: auswertung, dokument: dokument,
    blockText: blockText, blockMarkdown: blockMarkdown, blockHtml: blockHtml, druckCss: druckCss, achse: achse, cssText: cssText, vorschau: vorschau,
    geometrie: { balkenMonate: balkenMonate, balkenJahre: balkenJahre, linie: linie, ring: ring }
  };

  if (typeof module === 'object' && module && module.exports) {
    module.exports = api;
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  /* ------------------------------------------------------------------ DOM */

  var SVG_NS = 'http://www.w3.org/2000/svg';

  function zuDom(n, u, imSvg) {
    if (typeof n === 'string') return document.createTextNode(satz(n));
    if (n.icon) {
      var t = u.root && typeof u.root.querySelector === 'function' ? u.root.querySelector('template[data-mv-bp-icon="' + n.icon + '"]') : null;
      return t && t.content ? document.importNode(t.content, true) : null;
    }
    var svg = imSvg || n.t === 'svg';
    var e = svg ? document.createElementNS(SVG_NS, n.t) : document.createElement(n.t);
    Object.keys(n.a).forEach(function (key) {
      var v = n.a[key];
      if (v === null || v === undefined || v === false) return;
      e.setAttribute(key, v === true ? '' : String(v));
    });
    n.k.forEach(function (c) {
      var kind = zuDom(c, u, svg);
      if (kind) e.appendChild(kind);
    });
    return e;
  }

  /* K-A: Hinweis "wischen" (nur im Blatt, nicht in Datei und Text); sichtbar macht ihn passe(), wenn der Bereich
     danach ueberlaeuft */
  function hinweisBaum(text) {
    return el('p', { class: 'mv-bp-wischen', 'aria-hidden': 'true', hidden: true }, [{ icon: HINWEIS_ICON }, el('span', {}, [text])]);
  }

  /* Bausteine bp-* fuer baueDokument() in vorlagen.js (u = { root, id }). K-A: Tabellen kommen mit ihrem Hinweis
     davor (Fragment), breite Diagramme mit dem Hinweis vor der Flaeche; danach misst passe() das Blatt. */
  function blockDom(b, u) {
    var umgebung = u || {};
    var n = baum(b, { id: umgebung.id });
    if (!n) return null;
    var e;
    if (b.art === 'bp-tabelle') {
      e = document.createDocumentFragment();
      e.appendChild(zuDom(hinweisBaum(HINWEIS_TEXT.tabelle), umgebung, false));
      e.appendChild(zuDom(n, umgebung, false));
    } else {
      if (b.art === 'bp-diagramm' && b.typ !== 'ring') {
        for (var i = 0; i < n.k.length; i++) {
          if (n.k[i] && n.k[i].a && n.k[i].a.class === 'mv-bp-diagramm__flaeche') {
            n.k.splice(i, 0, hinweisBaum(HINWEIS_TEXT.diagramm));
            break;
          }
        }
      }
      e = zuDom(n, umgebung, false);
    }
    melde(umgebung.root);
    return e;
  }
  api.blockDom = blockDom;

  /* K-A: Vorschau im Blatt. Nach dem Zeichnen (ein Frame spaeter, dann haengt das Dokument im Blatt) und bei jeder
     Breitenaenderung des Dokumentbereichs: Seitenansicht oder Fliessen waehlen, danach die Hinweise setzen. */
  var GEPLANT = [];
  var BEOBACHTET = [];

  function melde(root) {
    if (!root || typeof root.querySelector !== 'function' || GEPLANT.indexOf(root) !== -1) return;
    GEPLANT.push(root);
    var los = function () {
      var liste = GEPLANT.slice();
      GEPLANT.length = 0;
      liste.forEach(passe);
    };
    if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(los);
    else window.setTimeout(los, 0);
  }

  function beobachte(root, box) {
    if (BEOBACHTET.indexOf(box) !== -1) return;
    BEOBACHTET.push(box);
    var breite = -1;
    if (typeof ResizeObserver === 'function') {
      /* nur die Breite zaehlt; die Hoehe aendert sich mit jedem Zeichnen und mit dem Faktor */
      new ResizeObserver(function () {
        var b = box.clientWidth;
        if (b !== breite) {
          breite = b;
          melde(root);
        }
      }).observe(box);
    } else {
      window.addEventListener('resize', function () { melde(root); });
    }
    /* Webschrift spaeter geladen: Tabellen werden breiter */
    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') document.fonts.ready.then(function () { melde(root); });
  }

  function setzeVorschau(box, modus, skala) {
    if (box.getAttribute('data-mv-bp-vorschau') !== modus) box.setAttribute('data-mv-bp-vorschau', modus);
    if (!box.style || typeof box.style.setProperty !== 'function') return;
    var s = String(Math.round(skala * 10000) / 10000);
    if (modus === 'seite') {
      if (box.style.getPropertyValue('--mvs-bp-skala') !== s) box.style.setProperty('--mvs-bp-skala', s);
    } else if (box.style.getPropertyValue('--mvs-bp-skala')) {
      box.style.removeProperty('--mvs-bp-skala');
    }
  }

  function passe(root) {
    var box = root.querySelector('[data-mv-vorlagen-dokument]');
    if (!box) return;
    beobachte(root, box);
    if (!box.hasAttribute('data-mv-bp-vorschau')) box.setAttribute('data-mv-bp-vorschau', 'fliesst');
    var dok = box.firstElementChild;
    /* Plan v1 (ohne Modul gezeichnet) oder noch kein Dokument: nichts zu messen */
    if (!dok || !dok.querySelector('.mv-bp-tabelle')) return;
    var verfuegbar = box.clientWidth;
    /* verborgen (mobil in der Ansicht Eingaben): der Beobachter meldet sich, sobald das Blatt Breite hat */
    if (!(verfuegbar > 0)) return;
    var rem = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
    var seite = VORSCHAU.seiteRem * rem;
    var bereiche = dok.querySelectorAll('.mv-bp-tabelle, .mv-bp-diagramm__flaeche');
    var v = { seite: false, skala: 1 };
    if (verfuegbar / seite >= VORSCHAU.faktorMin - 1e-9) {
      /* bei Seitenbreite (oder der breiteren Flaeche) messen, wie weit der breiteste Bereich ueberlaeuft */
      var l0 = Math.max(seite, verfuegbar);
      setzeVorschau(box, 'seite', verfuegbar / l0);
      var r = 1;
      for (var i = 0; i < bereiche.length; i++) if (bereiche[i].clientWidth > 0) r = Math.max(r, bereiche[i].scrollWidth / bereiche[i].clientWidth);
      v = vorschau(verfuegbar, Math.ceil(l0 * r), seite);
    }
    setzeVorschau(box, v.seite ? 'seite' : 'fliesst', v.skala);
    for (var j = 0; j < bereiche.length; j++) {
      var h = bereiche[j].previousElementSibling;
      if (!h || !h.classList || !h.classList.contains('mv-bp-wischen')) continue;
      var ueber = bereiche[j].scrollWidth > bereiche[j].clientWidth + 1;
      if (h.hidden === ueber) h.hidden = !ueber;
    }
  }

  /* Waechter: das Modul gibt es einmal je Seite */
  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.businessplan) return;
  MV.businessplan = api;

  /* Druck: Firmenname und Datum fuer die Seitenraender der benannten Seite mv-bp (assets/mv-sortiment.bp.css) */
  window.addEventListener('beforeprint', function () {
    var deck = document.querySelector('[data-mv-vorlagen="businessplan"] [data-mv-bp-kopfzeile]');
    var h = document.documentElement;
    if (!deck || !h.style || typeof h.style.setProperty !== 'function') return;
    h.style.setProperty('--mvs-bp-kopf', cssText(deck.getAttribute('data-mv-bp-kopfzeile') || ''));
    h.style.setProperty('--mvs-bp-fuss', cssText(deck.getAttribute('data-mv-bp-fusszeile') || ''));
  });
  window.addEventListener('afterprint', function () {
    var h = document.documentElement;
    if (!h.style || typeof h.style.removeProperty !== 'function') return;
    h.style.removeProperty('--mvs-bp-kopf');
    h.style.removeProperty('--mvs-bp-fuss');
  });

  /* ------------------------------------------------------------------ Konto-Bruecke (Paket A-2a, siehe Kopf) */

  var BRUECKE = { root: null, text: '', start: null, aktiv: false, gelesen: false, geplant: false };

  /* MVKonto steht im Buendel nach dieser Datei, vorlagen.js ebenso: beides erst beim Aufruf aufloesen */
  function kontoApi() {
    var k = window.MVKonto;
    return k && typeof k.speichern === 'function' && typeof k.lesen === 'function' && typeof k.loeschen === 'function' ? k : null;
  }

  function vorlagenApi() {
    var v = MV.vorlagen;
    return v && typeof v.leseZustand === 'function' && typeof v.zustandText === 'function' && v.SPEICHER && v.SPEICHER.businessplan ? v : null;
  }

  /* Felder wie vorlagen.js sie liest (Haken als Wahrheitswert, Radiogruppe als gewaehlter Wert) */
  function formWerte(root) {
    var o = {};
    var liste = root.querySelectorAll('[data-mv-vorlagen-feld]');
    for (var i = 0; i < liste.length; i++) {
      var el = liste[i];
      if (!el.name) continue;
      if (el.type === 'checkbox') o[el.name] = !!el.checked;
      else if (el.type === 'radio') {
        if (el.checked) o[el.name] = el.value;
      } else o[el.name] = el.value;
    }
    return o;
  }

  function schrittVon(root) {
    var f = root.querySelector('fieldset[data-mv-vorlagen-schritt]:not([hidden])');
    return f ? f.getAttribute('data-mv-vorlagen-schritt') || '' : '';
  }

  function standJetzt(root) {
    return kontoStand(formWerte(root), schrittVon(root));
  }

  function vergleichText(s) {
    return JSON.stringify([s.werte, s.schritt]);
  }

  function statusText(root) {
    var el = root.querySelector('[data-mv-vorlagen-status]');
    return el ? el.textContent : '';
  }

  function inWurzel(el) {
    return !!(BRUECKE.aktiv && BRUECKE.root && el && BRUECKE.root.contains(el));
  }

  /* Direkt nach dem Ereignis pruefen: vorlagen.js hat dann gerechnet, Felder vorbelegt und seinen Speicher geschrieben
     (seine Listener laufen im selben Ereignis nach diesen). Mikrotask statt Timer: der Stand liegt im Spiegel, bevor
     eine Antwort des Kontos verarbeitet wird (sonst koennte ein gleichzeitig eintreffender Konto-Stand eine Eingabe
     ueberholen). */
  function planen() {
    if (BRUECKE.geplant) return;
    BRUECKE.geplant = true;
    var los = function () {
      BRUECKE.geplant = false;
      pruefen();
    };
    if (typeof window.Promise === 'function') window.Promise.resolve().then(los);
    else window.setTimeout(los, 0);
  }

  function pruefen() {
    var root = BRUECKE.root;
    var mv = kontoApi();
    if (!BRUECKE.aktiv || !root || !mv) return;
    var s = standJetzt(root);
    var t = vergleichText(s);
    if (t === BRUECKE.text) return;
    /* vor dem ersten Abgleich nur geblaettert (Schritt, keine Eingabe): den Konto-Stand abwarten, nichts ueberschreiben */
    if (!BRUECKE.gelesen && BRUECKE.start && gleicheWerte(s.werte, BRUECKE.start.werte)) return;
    BRUECKE.text = t;
    mv.speichern(KONTO_WERKZEUG, s);
  }

  /* "Eingaben loeschen": vorlagen.js fragt nach; geloescht ist, wenn sich der Stand aendert und der Status "geleert"
     meldet. Dann auch im Konto loeschen statt den leeren Stand zu speichern. */
  function nachLeeren() {
    var root = BRUECKE.root;
    var mv = kontoApi();
    var v = vorlagenApi();
    if (!BRUECKE.aktiv || !root || !mv) return;
    var s = standJetzt(root);
    var t = vergleichText(s);
    if (t === BRUECKE.text) return;
    BRUECKE.text = t;
    if (v && v.TEXTE && v.TEXTE.ui && statusText(root) === v.TEXTE.ui.geleert) {
      /* geleert ist eine Eingabe: ein spaeter eintreffender Konto-Stand ersetzt sie nicht */
      if (BRUECKE.start) BRUECKE.start = { werte: {}, schritt: '' };
      mv.loeschen(KONTO_WERKZEUG);
    } else mv.speichern(KONTO_WERKZEUG, s);
  }

  document.addEventListener('input', function (e) {
    if (inWurzel(e.target)) planen();
  });
  document.addEventListener('change', function (e) {
    if (inWurzel(e.target)) planen();
  });
  /* Klicks: Schritte, Zeilen, Beispiel aendern den Stand ohne input-Ereignis; "Eingaben loeschen" gesondert */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!inWurzel(t)) return;
    if (typeof t.closest === 'function' && t.closest('[data-mv-vorlagen-aktion="leeren"]')) {
      if (typeof window.Promise === 'function') window.Promise.resolve().then(nachLeeren);
      else window.setTimeout(nachLeeren, 0);
      return;
    }
    planen();
  });

  /* vorlagen.js startet eine Sektion bei shopify:section:load neu (wie im Theme-Editor) und liest dabei seinen
     Speicher, den MVKonto beim Uebernehmen des Konto-Stands nachgefuehrt hat (geteilter Altschluessel) */
  function neuStarten(root) {
    var e = null;
    try {
      e = new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: '', mvKonto: true } });
    } catch (f) {
      e = null;
    }
    if (e) root.dispatchEvent(e);
  }

  /* Hat MVKonto einen Konto-Stand uebernommen (geteilten Schluessel ueberschrieben), obwohl auf der Seite schon
     eingegeben wurde (Geraeteuhr hinter der Server-Uhr), gilt das Formular: ein change an einem neutralen Feld laesst
     vorlagen.js seinen Speicher wieder aus dem Formular schreiben */
  function vorlagenSpeichern(root) {
    var f = root.querySelector('[data-mv-vorlagen-feld][name="vorhaben.name"]') || root.querySelector('[data-mv-vorlagen-feld]');
    if (f && typeof Event === 'function') f.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function nachBereit(root, fn) {
    if (root.hasAttribute('data-mv-vorlagen-bereit')) {
      fn();
      return;
    }
    if (typeof window.MutationObserver !== 'function') return;
    var b = new window.MutationObserver(function () {
      if (!root.hasAttribute('data-mv-vorlagen-bereit')) return;
      b.disconnect();
      fn();
    });
    b.observe(root, { attributes: true, attributeFilter: ['data-mv-vorlagen-bereit'] });
  }

  function verbinden(root, mv) {
    if (BRUECKE.aktiv && BRUECKE.root === root) return;
    BRUECKE.root = root;
    BRUECKE.aktiv = true;
    BRUECKE.gelesen = false;
    BRUECKE.start = standJetzt(root);
    BRUECKE.text = vergleichText(BRUECKE.start);
    var box = root.querySelector('[data-mv-konto-hinweis]');
    if (box && typeof mv.hinweis === 'function') mv.hinweis(box, KONTO_WERKZEUG);
    /* Spiegel anlegen bzw. den bisherigen Stand von vorlagen.js einmalig uebernehmen (Adapter, geteilt) */
    if (typeof mv.lokal === 'function') mv.lokal(KONTO_WERKZEUG);
    mv.lesen(KONTO_WERKZEUG).then(function (r) {
      BRUECKE.gelesen = true;
      if (BRUECKE.root !== root) return;
      var jetzt = standJetzt(root);
      /* Eingaben seit dem Start sind schon im Spiegel (juenger als das Konto, also hochgeladen) und bleiben stehen */
      var eingegeben = !gleicheWerte(jetzt.werte, BRUECKE.start.werte);
      if (r && !eingegeben && ((r.neu && r.altschluessel) || r.verworfen)) {
        neuStarten(root);
        BRUECKE.text = vergleichText(standJetzt(root));
        return;
      }
      /* neuer Konto-Stand, den vorlagen.js nicht lesen kann (kein Browser-Speicher): nichts ueberschreiben */
      if (r && r.neu && !eingegeben) return;
      if (r && r.neu && r.altschluessel) vorlagenSpeichern(root);
      if (r && r.stand && !gleicherStand(kontoStand(r.stand.werte, r.stand.schritt), jetzt)) {
        BRUECKE.text = vergleichText(jetzt);
        mv.speichern(KONTO_WERKZEUG, jetzt);
      }
    }, function () {
      BRUECKE.gelesen = true;
    });
  }

  function kontoStart() {
    var mv = kontoApi();
    var v = vorlagenApi();
    /* A-2b: speichert vorlagen.js selbst ueber MVKonto (api.kontoSelbst), tritt die Bruecke zurueck */
    if (!mv || !v || v.kontoSelbst) return;
    var root = document.querySelector('[data-mv-vorlagen="businessplan"]');
    if (!root) return;
    if (typeof mv.migration === 'function') {
      mv.migration(/^businessplan$/, {
        geteilt: true,
        alt: function () { return v.SPEICHER.businessplan; },
        lesen: function (text) {
          var z = v.leseZustand(text);
          return z ? kontoStand(z.werte, z.schritt || '') : null;
        },
        schreiben: function (stand) {
          var w = stand && stand.werte && typeof stand.werte === 'object' ? stand.werte : {};
          return v.zustandText({ v: 1, werte: w, schritt: stand && typeof stand.schritt === 'string' ? stand.schritt : '', erledigt: [] });
        }
      });
    }
    nachBereit(root, function () { verbinden(root, mv); });
  }

  function nachBuendel(fn) {
    if (window.MVKonto || typeof window.Promise !== 'function') fn();
    else window.Promise.resolve().then(fn);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { nachBuendel(kontoStart); });
  else nachBuendel(kontoStart);
})();
